/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 2015-05-07.2
 *
 * By Eli Grey, http://eligrey.com
 * License: X11/MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
        "use strict";
        // IE <10 is explicitly unsupported
        if (typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
            return;
        }
        var
            doc = view.document
        // only get URL when necessary in case Blob.js hasn't overridden it yet
            , get_URL = function() {
                return view.URL || view.webkitURL || view;
            }
            , save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
            , can_use_save_link = "download" in save_link
            , click = function(node) {
                var event = doc.createEvent("MouseEvents");
                event.initMouseEvent(
                    "click", true, false, view, 0, 0, 0, 0, 0
                    , false, false, false, false, 0, null
                );
                node.dispatchEvent(event);
            }
            , webkit_req_fs = view.webkitRequestFileSystem
            , req_fs = view.requestFileSystem || webkit_req_fs || view.mozRequestFileSystem
            , throw_outside = function(ex) {
                (view.setImmediate || view.setTimeout)(function() {
                    throw ex;
                }, 0);
            }
            , force_saveable_type = "application/octet-stream"
            , fs_min_size = 0
        // See https://code.google.com/p/chromium/issues/detail?id=375297#c7 and
        // https://github.com/eligrey/FileSaver.js/commit/485930a#commitcomment-8768047
        // for the reasoning behind the timeout and revocation flow
            , arbitrary_revoke_timeout = 500 // in ms
            , revoke = function(file) {
                var revoker = function() {
                    if (typeof file === "string") { // file is an object URL
                        get_URL().revokeObjectURL(file);
                    } else { // file is a File
                        file.remove();
                    }
                };
                if (view.chrome) {
                    revoker();
                } else {
                    setTimeout(revoker, arbitrary_revoke_timeout);
                }
            }
            , dispatch = function(filesaver, event_types, event) {
                event_types = [].concat(event_types);
                var i = event_types.length;
                while (i--) {
                    var listener = filesaver["on" + event_types[i]];
                    if (typeof listener === "function") {
                        try {
                            listener.call(filesaver, event || filesaver);
                        } catch (ex) {
                            throw_outside(ex);
                        }
                    }
                }
            }
            , auto_bom = function(blob) {
                // prepend BOM for UTF-8 XML and text/* types (including HTML)
                if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
                    return new Blob(["\ufeff", blob], {type: blob.type});
                }
                return blob;
            }
            , FileSaver = function(blob, name) {
                blob = auto_bom(blob);
                // First try a.download, then web filesystem, then object URLs
                var
                    filesaver = this
                    , type = blob.type
                    , blob_changed = false
                    , object_url
                    , target_view
                    , dispatch_all = function() {
                        dispatch(filesaver, "writestart progress write writeend".split(" "));
                    }
                // on any filesys errors revert to saving with object URLs
                    , fs_error = function() {
                        // don't create more object URLs than needed
                        if (blob_changed || !object_url) {
                            object_url = get_URL().createObjectURL(blob);
                        }
                        if (target_view) {
                            target_view.location.href = object_url;
                        } else {
                            var new_tab = view.open(object_url, "_blank");
                            if (new_tab == undefined && typeof safari !== "undefined") {
                                //Apple do not allow window.open, see http://bit.ly/1kZffRI
                                view.location.href = object_url
                            }
                        }
                        filesaver.readyState = filesaver.DONE;
                        dispatch_all();
                        revoke(object_url);
                    }
                    , abortable = function(func) {
                        return function() {
                            if (filesaver.readyState !== filesaver.DONE) {
                                return func.apply(this, arguments);
                            }
                        };
                    }
                    , create_if_not_found = {create: true, exclusive: false}
                    , slice
                    ;
                filesaver.readyState = filesaver.INIT;
                if (!name) {
                    name = "download";
                }
                if (can_use_save_link) {
                    object_url = get_URL().createObjectURL(blob);
                    save_link.href = object_url;
                    save_link.download = name;
                    click(save_link);
                    filesaver.readyState = filesaver.DONE;
                    dispatch_all();
                    revoke(object_url);
                    return;
                }
                // Object and web filesystem URLs have a problem saving in Google Chrome when
                // viewed in a tab, so I force save with application/octet-stream
                // http://code.google.com/p/chromium/issues/detail?id=91158
                // Update: Google errantly closed 91158, I submitted it again:
                // https://code.google.com/p/chromium/issues/detail?id=389642
                if (view.chrome && type && type !== force_saveable_type) {
                    slice = blob.slice || blob.webkitSlice;
                    blob = slice.call(blob, 0, blob.size, force_saveable_type);
                    blob_changed = true;
                }
                // Since I can't be sure that the guessed media type will trigger a download
                // in WebKit, I append .download to the filename.
                // https://bugs.webkit.org/show_bug.cgi?id=65440
                if (webkit_req_fs && name !== "download") {
                    name += ".download";
                }
                if (type === force_saveable_type || webkit_req_fs) {
                    target_view = view;
                }
                if (!req_fs) {
                    fs_error();
                    return;
                }
                fs_min_size += blob.size;
                req_fs(view.TEMPORARY, fs_min_size, abortable(function(fs) {
                    fs.root.getDirectory("saved", create_if_not_found, abortable(function(dir) {
                        var save = function() {
                            dir.getFile(name, create_if_not_found, abortable(function(file) {
                                file.createWriter(abortable(function(writer) {
                                    writer.onwriteend = function(event) {
                                        target_view.location.href = file.toURL();
                                        filesaver.readyState = filesaver.DONE;
                                        dispatch(filesaver, "writeend", event);
                                        revoke(file);
                                    };
                                    writer.onerror = function() {
                                        var error = writer.error;
                                        if (error.code !== error.ABORT_ERR) {
                                            fs_error();
                                        }
                                    };
                                    "writestart progress write abort".split(" ").forEach(function(event) {
                                        writer["on" + event] = filesaver["on" + event];
                                    });
                                    writer.write(blob);
                                    filesaver.abort = function() {
                                        writer.abort();
                                        filesaver.readyState = filesaver.DONE;
                                    };
                                    filesaver.readyState = filesaver.WRITING;
                                }), fs_error);
                            }), fs_error);
                        };
                        dir.getFile(name, {create: false}, abortable(function(file) {
                            // delete file if it already exists
                            file.remove();
                            save();
                        }), abortable(function(ex) {
                            if (ex.code === ex.NOT_FOUND_ERR) {
                                save();
                            } else {
                                fs_error();
                            }
                        }));
                    }), fs_error);
                }), fs_error);
            }
            , FS_proto = FileSaver.prototype
            , saveAs = function(blob, name) {
                return new FileSaver(blob, name);
            }
            ;
        // IE 10+ (native saveAs)
        if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
            return function(blob, name) {
                return navigator.msSaveOrOpenBlob(auto_bom(blob), name);
            };
        }

        FS_proto.abort = function() {
            var filesaver = this;
            filesaver.readyState = filesaver.DONE;
            dispatch(filesaver, "abort");
        };
        FS_proto.readyState = FS_proto.INIT = 0;
        FS_proto.WRITING = 1;
        FS_proto.DONE = 2;

        FS_proto.error =
            FS_proto.onwritestart =
                FS_proto.onprogress =
                    FS_proto.onwrite =
                        FS_proto.onabort =
                            FS_proto.onerror =
                                FS_proto.onwriteend =
                                    null;

        return saveAs;
    }(
        typeof self !== "undefined" && self
        || typeof window !== "undefined" && window
        || this.content
    ));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
    module.exports.saveAs = saveAs;
} else if ((typeof define !== "undefined" && define !== null) && (define.amd != null)) {
    define([], function() {
        return saveAs;
    });
}

(function() {
    'use strict';

    angular
        .module('schulausflugApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'uiGmapgoogle-maps',
            'infinite-scroll'
        ])
        .filter('checkmark', function() {
            return function getCheckmark(input) {
                return input ? '\u2713' : '\u2718';
            }})
        .filter('category', function() {
            return function getCategory(input) {
                switch(input) {
                    case 'DAYTRIP':
                        return 'Tagesausflug';
                    case 'ACCOMMODATION':
                        return 'Projekttag/Projektwoche';
                    case 'BUSCOMPANY':
                        return 'Busunternehmen';
                    default:
                        return 'Unbekannt';
                }
            }})
        .filter('categoryPlural', function() {
            return function getCategory(input) {
                switch(input) {
                    case 'DAYTRIP':
                        return 'Tagesausflüge';
                    case 'ACCOMMODATION':
                        return 'Projekttage/Projektwochen';
                    case 'BUSCOMPANY':
                        return 'Busunternehmen';
                    default:
                        return 'Unbekannt';
                }
            }})
        .filter('subcategory', function() {
            return function getSubcategory(input) {
                switch(input) {
                    case 'ALLWEATHERS':
                        return 'Bei jedem Wetter';
                    case 'OUTDOOR':
                        return 'Outdoor';
                    case 'WINTER':
                        return 'Winter';
                    default:
                        return 'Unbekannt';
                }
            }})
        .filter('gender', function() {
            return function getTypeString(input) {
                return input=='MALE' ? 'Männlich' : 'Weiblich';
            }})
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('UserCompanyResultController', UserCompanyResultController);

    UserCompanyResultController.$inject = ['$scope', '$state', '$stateParams','UserCompany'];

    function UserCompanyResultController ($scope, $state, $stateParams, UserCompany) {
        var vm = this;
        $scope.mapCenters = {};
        $scope.mapMarkers = {};
        $scope.mapZoom = 6;
        $scope.busy = false;
        var randomCompany = $stateParams.company;
        var search = $stateParams.search;
        vm.companies = [];
        if($stateParams.company!=null) {
            $scope.mapCenters[randomCompany.id] = { latitude: randomCompany.latitude, longitude: randomCompany.longitude};
            $scope.mapMarkers[randomCompany.id] = [{ id: Math.random(), coords: { latitude: randomCompany.latitude, longitude: randomCompany.longitude}}]
            vm.companies= [randomCompany];
        } else if(search!=null) {
            $scope.busy = true;
            UserCompany.query({search: search}, function(result){
                result.forEach(function(c) {
                    if(vm.companies==null) vm.companies=[];
                    $scope.mapCenters[c.id] = { latitude: c.latitude, longitude: c.longitude};
                    $scope.mapMarkers[c.id] = [{ id: Math.random(), coords: { latitude: c.latitude, longitude: c.longitude}}]
                    vm.companies.push(c);
                });
                $scope.busy = false;
            });
        } else {
            $state.go('home');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('daytrip', {
            parent: 'app',
            url: '/tagesausfluege?bl&sk',
            data: {
                authorities: []
            },
            params: {type: 'DAYTRIP'},
            views: {
                'content@': {
                    templateUrl: 'app/user-company/user-companies.html',
                    controller: 'UserCompanyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                companies: ['UserCompany', function(UserCompany) {
                    return UserCompany.query();
                }]
            }
        })
        .state('accommodation', {
            parent: 'app',
            url: '/projektwochen?bl&sk',
            data: {
                authorities: []
            },
            params: {type: 'ACCOMMODATION'},
            views: {
                'content@': {
                    templateUrl: 'app/user-company/user-companies.html',
                    controller: 'UserCompanyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                companies: ['UserCompany', function(UserCompany) {
                    return UserCompany.query();
                }]
            }
        })
        .state('buscompany', {
            parent: 'app',
            url: '/busunternehmen?bl&sk',
            data: {
                authorities: []
            },
            params: {type: 'BUSCOMPANY'},
            views: {
                'content@': {
                    templateUrl: 'app/user-company/user-companies.html',
                    controller: 'UserCompanyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                companies: ['UserCompany', function(UserCompany) {
                    return UserCompany.query();
                }]
            }
        })
        .state('search', {
            parent: 'app',
            url: '/unternehmen',
            data: {
                authorities: []
            },
            params: {
                search: null,
                company: null
            },
            views: {
                'content@': {
                    templateUrl: 'app/user-company/user-company-result.html',
                    controller: 'UserCompanyResultController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('UserCompany', UserCompany);

    UserCompany.$inject = ['$resource'];

    function UserCompany ($resource) {
        var resourceUrl =  'api/companies';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('UserCompanyController', UserCompanyController);

    UserCompanyController.$inject = ['$scope', '$stateParams', 'Principal', 'LoginService', '$state', 'State', 'CompaniesPerState','UserCompany', 'companies'];

    function UserCompanyController ($scope, $stateParams, Principal, LoginService, $state, State, CompaniesPerState, UserCompany, companies) {
        var vm = this;
        $scope.mapCenters = {};
        $scope.mapMarkers = {};
        $scope.mapZoom = 6;
        // $scope.mapOptions = {disableDefaultUI: true};
        $scope.busy = false;

        vm.loadNextCompaniesPage = loadNextCompaniesPage;
        vm.loadNextAdjacentCompaniesPage = loadNextAdjacentCompaniesPage;
        vm.getStateName = getStateName;
        vm.type = $stateParams.type;
        vm.state= $stateParams.bl;
        vm.stateName = null;
        vm.subCategory = $stateParams.sk;
        vm.states = [];
        vm.subCategories = ['ALLWEATHERS', 'OUTDOOR'/*, 'WINTER'*/];
        vm.companies = null;
        vm.adjacent_companies = null;
        vm.itemsPerPage = 10;
        vm.page = -1;
        vm.adjacentPage = -1;
        vm.hasNextPage = true;
        vm.hasNextAdjacentPage = true;
        loadAllStates();

        if(vm.state) {
            loadNextCompaniesPage();
        }

        function loadAllStates() {
            State.query({companyCategory: vm.type, adjacentCompanies: false, images: (vm.state==null)}, function(result) {
                vm.states = result;
                vm.searchQuery = null;
            });
        }

        function getStateName() {
            for(var i=0, len=vm.states.length; i < len; i++){
                if(vm.states[i].id==vm.state) return vm.states[i].name
            }
        }

        function loadNextCompaniesPage() {
            if ($scope.busy) return;
            $scope.busy = true;
            vm.page = vm.page+1;
            if(vm.companies==null) vm.companies = [];
            CompaniesPerState.query({id: vm.state, category: vm.type, subCategory: vm.subCategory, page: vm.page, size: vm.itemsPerPage},  function(result) {
                vm.hasNextPage = result.length > 0;
                result.forEach(function(c) {
                    $scope.mapCenters[c.id] = { latitude: c.latitude, longitude: c.longitude};
                    $scope.mapMarkers[c.id] = [{ id: Math.random(), coords: { latitude: c.latitude, longitude: c.longitude}}]
                    vm.companies.push(c);
                });
                $scope.busy = false;

                if(!vm.hasNextPage) {
                    loadNextAdjacentCompaniesPage();
                }
            });

        }

        function loadNextAdjacentCompaniesPage() {
            if ($scope.busy) return;
            $scope.busy = true;
            vm.adjacentPage = vm.adjacentPage+1;
            if(vm.adjacent_companies==null) vm.adjacent_companies = [];
            CompaniesPerState.query({id: vm.state, adjacent: true, category: vm.type, subCategory: vm.subCategory, page: vm.adjacentPage, size: vm.itemsPerPage},  function(result) {
                vm.hasNextAdjacentPage = result.length > 0;
                result.forEach(function(c) {
                    $scope.mapCenters[c.id] = { latitude: c.latitude, longitude: c.longitude};
                    $scope.mapMarkers[c.id] = [{ id: Math.random(), coords: { latitude: c.latitude, longitude: c.longitude}}];
                    vm.adjacent_companies.push(c);
                });
                $scope.busy = false;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tos', {
            parent: 'app',
            url: '/tos',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/tos/tos.html'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('inquiry', {
            parent: 'app',
            url: '/inquiry/{id}',
            data: {
                authorities: []
            },
            params: {
                company: null
            },
            views: {
                'content@': {
                    templateUrl: 'app/inquiry/inquiry.html',
                    controller: 'InquiryController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('inquiry-success', {
            parent: 'app',
            url: '/inquiry-success',
            data: {
                authorities: [],
                pageTitle: 'Anfrage erfolgreich'
            },
            views: {
                'content@': {
                    templateUrl: 'app/inquiry/inquiry-success.html'
                }
            }
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('Inquiry', Inquiry);

    Inquiry.$inject = ['$resource'];

    function Inquiry ($resource) {
        var resourceUrl =  'api/inquiry';

        return $resource(resourceUrl, {}, {
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('InquiryController', InquiryController);

    InquiryController.$inject = ['$scope', '$stateParams', '$state', 'DataUtils', 'Inquiry', 'Company'];

    function InquiryController ($scope, $stateParams, $state, DataUtils, Inquiry, Company) {
        var vm = this;

        vm.inquiry = {};
        vm.save = save;
        vm.error = null;
        vm.tos = false;
        vm.company = $stateParams.company;

        if($stateParams.id==null) {
            $state.go("home");
        } else {
            vm.inquiry.companyId = $stateParams.id;
        }

        if(vm.company==null) {
            vm.company = Company.get({id: $stateParams.id}, onGetSuccess, onGetError)
        }

        function onGetSuccess (result) {
            result
        }

        function onGetError() {
            $state.go("home");
        }

        function save() {
            vm.isSaving = true;
            Inquiry.save(vm.inquiry, onSaveSuccess, onSaveError)
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $state.go("inquiry-success");
            vm.error = null;
        }

        function onSaveError () {
            vm.isSaving = false;
            vm.error = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('NewsletterDialogController', NewsletterDialogController);

    NewsletterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'Newsletter'];

    function NewsletterDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, Newsletter) {
        var vm = this;

        vm.newsletter = {};
        vm.clear = clear;
        vm.save = save;
        vm.error = null;
        vm.tos = false;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
            vm.error = null;
        }

        function save () {
            vm.isSaving = true;
            Newsletter.save(vm.newsletter, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.error = null;
        }

        function onSaveError () {
            vm.isSaving = false;
            vm.error = true;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('Newsletter', Newsletter);

    Newsletter.$inject = ['$resource'];

    function Newsletter ($resource) {
        var resourceUrl =  'api/newsletter';

        return $resource(resourceUrl, {}, {
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('home.newsletter', {
            parent: 'home',
            url: 'newsletter',
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/home/newsletter-dialog.html',
                    controller: 'NewsletterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md'
                }).result.then(function() {
                    $state.go('home', null, { reload: 'home' });
                }, function() {
                    $state.go('home');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'FilteredNews', 'RandomCompany', 'Company'];

    function HomeController ($scope, Principal, LoginService, $state, FilteredNews, RandomCompany, Company) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.news = FilteredNews.query();
        vm.randomCompany = RandomCompany.get();
        vm.searchText = null;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('StateDialogController', StateDialogController);

    StateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'State', 'Company', 'DataUtils'];

    function StateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, State, Company, DataUtils) {
        var vm = this;

        vm.state = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query();
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.state.id !== null) {
                State.update(vm.state, onSaveSuccess, onSaveError);
            } else {
                State.save(vm.state, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('schulausflugApp:stateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.setImage = function ($file, state) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        state.image = base64Data;
                        state.imageContentType = $file.type;
                    });
                });
            }
        };


    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('StateDetailController', StateDetailController);

    StateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'State', 'Company'];

    function StateDetailController($scope, $rootScope, $stateParams, previousState, entity, State, Company) {
        var vm = this;

        vm.state = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('schulausflugApp:stateUpdate', function(event, result) {
            vm.state = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('StateDeleteController',StateDeleteController);

    StateDeleteController.$inject = ['$uibModalInstance', 'entity', 'State'];

    function StateDeleteController($uibModalInstance, entity, State) {
        var vm = this;

        vm.state = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            State.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('state', {
            parent: 'entity',
            url: '/state',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'States'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/state/states.html',
                    controller: 'StateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('state-detail', {
            parent: 'state',
            url: '/state/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'State'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/state/state-detail.html',
                    controller: 'StateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'State', function($stateParams, State) {
                    return State.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'state',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('state-detail.edit', {
            parent: 'state-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-dialog.html',
                    controller: 'StateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['State', function(State) {
                            return State.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('state.new', {
            parent: 'state',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-dialog.html',
                    controller: 'StateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('state', null, { reload: 'state' });
                }, function() {
                    $state.go('state');
                });
            }]
        })
        .state('state.edit', {
            parent: 'state',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-dialog.html',
                    controller: 'StateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['State', function(State) {
                            return State.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('state', null, { reload: 'state' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('state.delete', {
            parent: 'state',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-delete-dialog.html',
                    controller: 'StateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['State', function(State) {
                            return State.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('state', null, { reload: 'state' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('State', State);

    State.$inject = ['$resource'];

    function State ($resource) {
        var resourceUrl =  'api/states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('StateController', StateController);

    StateController.$inject = ['State', 'DataUtils'];

    function StateController(State, DataUtils) {

        var vm = this;

        vm.states = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            State.query(function(result) {
                vm.states = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('CompaniesPerState', CompaniesPerState);

    CompaniesPerState.$inject = ['$resource'];

    function CompaniesPerState ($resource) {
        var resourceUrl =  'api/states/:id/companies';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('NewsDialogController', NewsDialogController);

    NewsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'News'];

    function NewsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, News) {
        var vm = this;

        vm.news = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.news.id !== null) {
                News.update(vm.news, onSaveSuccess, onSaveError);
            } else {
                News.save(vm.news, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('schulausflugApp:newsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('NewsDetailController', NewsDetailController);

    NewsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'News'];

    function NewsDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, News) {
        var vm = this;

        vm.news = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('schulausflugApp:newsUpdate', function(event, result) {
            vm.news = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('NewsDeleteController',NewsDeleteController);

    NewsDeleteController.$inject = ['$uibModalInstance', 'entity', 'News'];

    function NewsDeleteController($uibModalInstance, entity, News) {
        var vm = this;

        vm.news = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            News.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('news', {
            parent: 'entity',
            url: '/news',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'News'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/news/news.html',
                    controller: 'NewsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('news-detail', {
            parent: 'news',
            url: '/news/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'News'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/news/news-detail.html',
                    controller: 'NewsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'News', function($stateParams, News) {
                    return News.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'news',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('news-detail.edit', {
            parent: 'news-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-dialog.html',
                    controller: 'NewsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['News', function(News) {
                            return News.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('news.new', {
            parent: 'news',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-dialog.html',
                    controller: 'NewsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                content: null,
                                url: null,
                                startDate: null,
                                endDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('news', null, { reload: 'news' });
                }, function() {
                    $state.go('news');
                });
            }]
        })
        .state('news.edit', {
            parent: 'news',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-dialog.html',
                    controller: 'NewsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['News', function(News) {
                            return News.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('news', null, { reload: 'news' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('news.delete', {
            parent: 'news',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/news/news-delete-dialog.html',
                    controller: 'NewsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['News', function(News) {
                            return News.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('news', null, { reload: 'news' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('News', News);

    News.$inject = ['$resource', 'DateUtils'];

    function News ($resource, DateUtils) {
        var resourceUrl =  'api/news/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('NewsController', NewsController);

    NewsController.$inject = ['DataUtils', 'News'];

    function NewsController(DataUtils, News) {

        var vm = this;

        vm.news = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            News.query(function(result) {
                vm.news = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('FilteredNews', FilteredNews);

    FilteredNews.$inject = ['$resource', 'DateUtils'];

    function FilteredNews ($resource, DateUtils) {
        var resourceUrl =  'api/filteredNews';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('InvoicesPerContract', InvoicesPerContract);

    InvoicesPerContract.$inject = ['$resource'];

    function InvoicesPerContract ($resource) {
        var resourceUrl =  'api/contracts/:id/invoices';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('InvoiceEmailController',InvoiceEmailController);

    InvoiceEmailController.$inject = ['$http','$uibModalInstance', 'entity'];

    function InvoiceEmailController($http,$uibModalInstance, entity) {
        var vm = this;

        vm.invoice = entity;
        vm.clear = clear;
        vm.sendPDFEmail = sendPDFEmail;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function sendPDFEmail (id) {
            $http.post('api/invoices/'+id+'/email').then(function () {
                $uibModalInstance.close(true);
            }, function (error) {
            //TODO: report error
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('InvoiceDialogController', InvoiceDialogController);

    InvoiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Invoice', 'Contract'];

    function InvoiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Invoice, Contract) {
        var vm = this;

        vm.invoice = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.contracts = Contract.query();

        vm.invoice.contractId = $stateParams.id;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.invoice.id !== null) {
                Invoice.update(vm.invoice, onSaveSuccess, onSaveError);
            } else {
                Invoice.save(vm.invoice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('schulausflugApp:invoiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('InvoiceDetailController', InvoiceDetailController);

    InvoiceDetailController.$inject = ['$http', '$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Invoice', 'Contract'];

    function InvoiceDetailController($http, $scope, $rootScope, $stateParams, previousState, DataUtils, entity, Invoice, Contract) {
        var vm = this;

        vm.invoice = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.downloadPDF = downloadPDF;

        var unsubscribe = $rootScope.$on('schulausflugApp:invoiceUpdate', function(event, result) {
            vm.invoice = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function downloadPDF (id) {
            $http.get('api/invoices/'+id+'/pdf', {responseType: 'arraybuffer'}).then(function (response) {
                var blob = new Blob([response.data], {
                    type: "application/pdf"
                });

                var filename = "Rechnung_"+id+".pdf";
                saveAs(blob, filename);
            }, function (error) {
                //TODO: report error
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('InvoiceDeleteController',InvoiceDeleteController);

    InvoiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Invoice'];

    function InvoiceDeleteController($uibModalInstance, entity, Invoice) {
        var vm = this;

        vm.invoice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Invoice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice', {
            parent: 'entity',
            url: '/invoice?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Invoices'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice/invoices.html',
                    controller: 'InvoiceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'issued,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('invoice-detail', {
            parent: 'entity',
            url: '/admin/invoice/{invoice_id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Rechnung'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice/invoice-detail.html',
                    controller: 'InvoiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Invoice', function($stateParams, Invoice) {
                    return Invoice.get({id : $stateParams.invoice_id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'invoice',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('invoice-detail.edit', {
            parent: 'invoice-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.invoice_id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-detail', { id: $stateParams.id, invoice_id: $stateParams.invoice_id}, { reload: 'invoice-detail' });
                }, function() {
                    $state.go('invoice-detail', { id: $stateParams.id, invoice_id: $stateParams.invoice_id}, { reload: 'invoice-detail' });
                });
            }]
        })
        .state('contract-detail.new-invoice', {
            parent: 'contract-detail',
            url: '/new-invoice',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                notes: null,
                                fee: null,
                                recipientCompanyName: null,
                                recipientName: null,
                                recipientZip: null,
                                recipientCountry: null,
                                recipientStreetName: null,
                                recipientStreetNumber: null,
                                recipientCity: null,
                                recipientEmail: null,
                                date: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('contract-detail', null, { reload: 'contract-detail' });
                }, function() {
                    $state.go('contract-detail');
                });
            }]
        })
        .state('contract-detail.edit-invoice', {
            parent: 'contract-detail',
            url: '/invoice/{invoice_id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.invoice_id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contract-detail', null, { reload: 'contract-detail' });
                }, function() {
                    $state.go('contract-detail');
                });
            }]
        })
        .state('contract-detail.delete-invoice', {
            parent: 'contract-detail',
            url: '/invoice/{invoice_id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-delete-dialog.html',
                    controller: 'InvoiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.invoice_id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contract-detail', null, { reload: 'contract-detail' });
                }, function() {
                    $state.go('contract-detail');
                });
            }]
        })
        .state('contract-detail.send-invoice', {
            parent: 'contract-detail',
            url: '/invoice/{invoice_id}/sendEmail',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-email-dialog.html',
                    controller: 'InvoiceEmailController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Invoice', function (Invoice) {
                            return Invoice.get({id: $stateParams.invoice_id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('contract-detail', null, {reload: 'contract-detail'});
                }, function () {
                    $state.go('contract-detail');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('Invoice', Invoice);

    Invoice.$inject = ['$resource', 'DateUtils'];

    function Invoice ($resource, DateUtils) {
        var resourceUrl =  'api/invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                        data.issued = DateUtils.convertDateTimeFromServer(data.issued);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('InvoiceController', InvoiceController);

    InvoiceController.$inject = ['$state', 'DataUtils', 'Invoice', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function InvoiceController($state, DataUtils, Invoice, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            Invoice.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.invoices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('ContractsPerCompany', ContractsPerCompany);

    ContractsPerCompany.$inject = ['$resource'];

    function ContractsPerCompany ($resource) {
        var resourceUrl =  'api/companies/:id/contracts';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('ContractDialogController', ContractDialogController);

    ContractDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Contract', 'Invoice', 'Company'];

    function ContractDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Contract, Invoice, Company) {
        var vm = this;

        vm.contract = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.invoices = Invoice.query();
        vm.companies = Company.query();

        //if create dialog
        if(vm.contract.id == null) vm.contract.companyId = $stateParams.id;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.contract.id !== null) {
                Contract.update(vm.contract, onSaveSuccess, onSaveError);
            } else {
                Contract.save(vm.contract, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('schulausflugApp:contractUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.invoiceDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('ContractDetailController', ContractDetailController);

    ContractDetailController.$inject = ['$http','$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Contract', 'Invoice', 'Company', 'InvoicesPerContract'];

    function ContractDetailController($http, $scope, $rootScope, $stateParams, previousState, DataUtils, entity, Contract, Invoice, Company, InvoicesPerContract) {
        var vm = this;

        vm.contract = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        vm.contract.invoices = InvoicesPerContract.get({id : vm.contract.id});

        vm.downloadPDF = downloadPDF;

        var unsubscribe = $rootScope.$on('schulausflugApp:contractUpdate', function(event, result) {
            vm.contract = result;
        });
        $scope.$on('$destroy', unsubscribe);


        function downloadPDF (id) {
            $http.get('api/invoices/'+id+'/pdf', {responseType: 'arraybuffer'}).then(function (response) {
                var blob = new Blob([response.data], {
                    type: "application/pdf"
                });

                var filename = "Rechnung_"+id+".pdf";
                saveAs(blob, filename);
            }, function (error) {
            //TODO: report error
            })
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('ContractDeleteController',ContractDeleteController);

    ContractDeleteController.$inject = ['$uibModalInstance', 'entity', 'Contract'];

    function ContractDeleteController($uibModalInstance, entity, Contract) {
        var vm = this;

        vm.contract = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Contract.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('contract', {
            parent: 'entity',
            url: '/contract?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Verträge'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/contract/contracts.html',
                    controller: 'ContractController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'endDate,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('contract-detail', {
            parent: 'entity',
            url: '/admin/contract/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Vertrag'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/contract/contract-detail.html',
                    controller: 'ContractDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Contract', function($stateParams, Contract) {
                    return Contract.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'contract',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('contract-detail.edit', {
            parent: 'contract-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract/contract-dialog.html',
                    controller: 'ContractDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Contract', function(Contract) {
                            return Contract.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contract-detail', { id: $stateParams.id}, { reload: 'contract-detail' });
                }, function() {
                    $state.go('contract-detail', { id: $stateParams.id}, { reload: 'contract-detail' });
                });
            }]
        })
        .state('company-detail.new-contract', {
            parent: 'company-detail',
            url: '/new-contract',
            data: {
                authorities: ['ROLE_USER']
            },
            params: {
              base_contract: null
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract/contract-dialog.html',
                    controller: 'ContractDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            if($stateParams.base_contract!=null) { //copying contract
                                var newContract = $stateParams.base_contract;
                                newContract.startDate = new Date($stateParams.base_contract.startDate);
                                newContract.endDate = new Date($stateParams.base_contract.endDate);
                                newContract.invoiceDate = new Date($stateParams.base_contract.invoiceDate);
                                newContract.id = null;
                                return newContract
                            }
                            return {
                                startDate: null,
                                endDate: null,
                                notes: null,
                                yearlyFee: null,
                                recipientCompanyName: null,
                                recipientName: null,
                                recipientZip: null,
                                recipientCountry: null,
                                recipientStreetName: null,
                                recipientStreetNumber: null,
                                recipientCity: null,
                                recipientEmail: null,
                                invoiceDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('company-detail', null, { reload: 'company-detail' });
                }, function() {
                    $state.go('company-detail');
                });
            }]
        })
        .state('company-detail.edit-contract', {
            parent: 'company-detail',
            url: '/contract/{contract_id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract/contract-dialog.html',
                    controller: 'ContractDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Contract', function(Contract) {
                            return Contract.get({id : $stateParams.contract_id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company-detail', null, { reload: 'company-detail' });
                }, function() {
                    $state.go('company-detail');
                });
            }]
        })
        .state('company-detail.delete-contract', {
            parent: 'company-detail',
            url: '/contract/{contract_id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract/contract-delete-dialog.html',
                    controller: 'ContractDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Contract', function(Contract) {
                            return Contract.get({id : $stateParams.contract_id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company-detail', null, { reload: 'company-detail' });
                }, function() {
                    $state.go('company-detail');
                });
            }]
        })
        .state('contract.edit', {
            parent: 'contract',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract/contract-dialog.html',
                    controller: 'ContractDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Contract', function(Contract) {
                            return Contract.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contract', null, { reload: 'contract' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contract.delete', {
            parent: 'contract',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract/contract-delete-dialog.html',
                    controller: 'ContractDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Contract', function(Contract) {
                            return Contract.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contract', null, { reload: 'contract' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('Contract', Contract);

    Contract.$inject = ['$resource', 'DateUtils'];

    function Contract ($resource, DateUtils) {
        var resourceUrl =  'api/contracts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                        data.invoiceDate = DateUtils.convertDateTimeFromServer(data.invoiceDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('ContractController', ContractController);

    ContractController.$inject = ['$state', 'DataUtils', 'Contract', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ContractController($state, DataUtils, Contract, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            Contract.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contracts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
/**
 * Created by alexander on 27/10/17.
 */

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('RandomCompany', RandomCompany);

    RandomCompany.$inject = ['$resource'];

    function RandomCompany ($resource) {
        var resourceUrl =  'api/randomCompany';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('CompanyDialogController', CompanyDialogController);

    CompanyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Company', 'Contract', 'State'];

    function CompanyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Company, Contract, State) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.contracts = Contract.query();
        vm.states = State.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.company.id !== null) {
                Company.update(vm.company, onSaveSuccess, onSaveError);
            } else {
                Company.save(vm.company, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('schulausflugApp:companyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImage = function ($file, company) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        company.image = base64Data;
                        company.imageContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('CompanyDetailController', CompanyDetailController);

    CompanyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'states', 'Company', 'Contract', 'State', 'ContractsPerCompany'];

    function CompanyDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, states, Company, Contract, State, ContractsPerCompany) {
        var vm = this;

        vm.company = entity;
        vm.states = states;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.stateNameById = stateNameById;
        vm.stateIdNameMapping = {};
        mapNamesToIds();

        vm.company.contracts = ContractsPerCompany.get({id : vm.company.id});

        function stateNameById(id) {
            return vm.stateIdNameMapping[id];
        }

        function mapNamesToIds() {
            vm.states.forEach(function(state) {
                vm.stateIdNameMapping[state.id] = state.name;
            });
        }

        var unsubscribe = $rootScope.$on('schulausflugApp:companyUpdate', function(event, result) {
            vm.company = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('CompanyDeleteController',CompanyDeleteController);

    CompanyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Company'];

    function CompanyDeleteController($uibModalInstance, entity, Company) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Company.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('company', {
            parent: 'entity',
            url: '/admin/company',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Betriebe'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/company/companies.html',
                    controller: 'CompanyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('company-detail', {
            parent: 'entity',
            url: '/admin/company/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Betrieb'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/company/company-detail.html',
                    controller: 'CompanyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Company', function($stateParams, Company) {
                    return Company.get({id : $stateParams.id}).$promise;
                }],
                states: ['State', function (State) {
                  return State.query().$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'company',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('company-detail.edit', {
            parent: 'company-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company-detail', {}, { reload: 'company-detail' });
                }, function() {
                    $state.go('company-detail');
                });
            }]
        })
        .state('company.new', {
            parent: 'company',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                image: null,
                                imageContentType: null,
                                imageText: null,
                                name: null,
                                email: null,
                                zip: null,
                                country: null,
                                streetName: null,
                                streetNumber: null,
                                city: null,
                                phone: null,
                                websiteURL: null,
                                facebookURL: null,
                                barrierFree: null,
                                notes: null,
                                position: null,
                                contactName: null,
                                contactPhone: null,
                                contactEmail: null,
                                category: null,
                                subCategory: null,
                                active: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: 'company' });
                }, function() {
                    $state.go('company');
                });
            }]
        })
        .state('company.edit', {
            parent: 'company',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: 'company' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company.delete', {
            parent: 'company',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-delete-dialog.html',
                    controller: 'CompanyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: 'company' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('schulausflugApp')
        .factory('Company', Company);

    Company.$inject = ['$resource'];

    function Company ($resource) {
        var resourceUrl =  'api/companies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('CompanyController', CompanyController);

    CompanyController.$inject = ['$state', 'DataUtils', 'Company', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CompanyController($state, DataUtils, Company, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            Company.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('contact', {
            parent: 'app',
            url: '/contact',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact/contact.html',
                    controller: 'ContactController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'contact',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('ContactController', ContactController);

    ContactController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function ContactController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        '{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'von {{$ctrl.queryCount}} Einträgen.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('schulausflugApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('schulausflugApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('schulausflugApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('schulausflugApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('schulausflugApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'schulausflug' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('schulausflugApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1682017687078)
;
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;



        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'schulausflug'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('schulausflugApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'email address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('schulausflugApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('schulausflugApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/contact/contact.html','<div ng-cloak><h3>Kontakt / Impressum</h3><div><img class="logo-img" src="content/images/03-Eibl-Fritz150180.jpg" alt="logo" style="float:right"><p>Medieninhaber und Betreiber</p><p>Service f\xFCr Jugendkultur Eibl&Eibl</p><p>Dipl. P\xE4d. Fritz Eibl, BEd</p><p>Dipl. P\xE4d. Eva Eibl</p><p>Kantnerm\xFChlstra\xDFe 5<br>A - 4701 Bad Schallerbach</p><p>Tel.: 0664 521 80 88</p><p>Mail: <a href="mailto:f.eibl@eduhi.at">f.eibl(at)eduhi.at</a></p><p>Unsere Nutzungsbedingungen k\xF6nnen Sie <a target="_blank" ui-sref="tos">hier</a> sehen.</p><p>Die angef\xFChrten Betriebe aus dem Waldviertel geh\xF6ren zum Projekt "Weiterentwicklung Jugendtourismus Waldviertel".</p><p>Das Projekt ist wie folgt gef\xF6rdert:</p><img class="sponsor-image" src="content/images/noewein.png"><p>Die Weinviertler Betriebe sind Teil des Projektes "Jugendtourismus Weinviertel 2.0", welches wie folgt gef\xF6rdert wird:</p><img class="sponsor-image" src="content/images/noewein.png"><p>Wir haben auf unseren Seiten Links zu anderen Seiten auf Web-Servern gelegt.</p><p>F\xFCr alle diese Links gilt:<br>Der verantwortliche Betreiber f\xFCr die Website www.schulausflug.at erkl\xE4rt ausdr\xFCcklich, dass er keinen Einfluss auf die Gestaltung und die Inhalte der gelinkten Seiten hat.</p><p>Der Betreiber hat auch auf die Richtigkeit der Inhalte und Verlinkungen nur Einfluss, sofern die \xC4nderungen an uns weitergeleitet wurden.</p></div></div>');
$templateCache.put('app/home/home.html','<!-- Page Content --><div ng-cloak><div class="row carousel-holder" style="margin-bottom: 1%"><div class="col-md-8"><div id="carousel-example-generic" class="carousel slide" data-ride="carousel"><ol class="carousel-indicators"><li data-target="#carousel-example-generic" data-slide-to="0" class="active"></li><li data-target="#carousel-example-generic" data-slide-to="1"></li></ol><div class="carousel-inner"><div class="item active"><img class="slide-image" src="content/images/banner_1.jpeg" alt=""></div><div class="item"><img class="slide-image" src="content/images/banner_2.jpg" alt=""></div></div><a class="left carousel-control" href="#carousel-example-generic" data-slide="prev"><span class="glyphicon glyphicon-chevron-left"></span> </a><a class="right carousel-control" href="#carousel-example-generic" data-slide="next"><span class="glyphicon glyphicon-chevron-right"></span></a></div></div><div class="col-md-4"><h1>Schulausflug</h1><p>Herzlich willkommen auf schulausflug.at - DIE Ideensammlung f\xFCr Ihre Schulveranstaltungen samt Kontaktm\xF6glichkeiten f\xFCr Tagesausfl\xFCge, Projekttage und Projektwochen in \xD6sterreich auf einen Blick.</p><a class="btn btn-primary home-btn" ui-sref="daytrip">Zu den Tagesausfl\xFCgen</a> <a class="btn btn-primary home-btn" ui-sref="accommodation">Zu den Projekttagen/Projektwochen</a> <a class="btn btn-primary home-btn" ui-sref="buscompany">Zu den Busunternehmen</a></div></div><div class="row" style="margin-bottom: 1%"><div class="col-md-8"><h4><i class="fa fa-fw fa-gift"></i>Tipp des Tages</h4><a class="btn btn-default" ui-sref="search({company: vm.randomCompany})">{{vm.randomCompany.name}}</a></div><div class="col-md-4"><h4><i class="fa fa-fw fa-search"></i>Suche</h4><form name="searchForm"><input type="text" placeholder="Mindestens 4 Zeichen" name="searchText" ng-model="vm.searchText"> <button ng-disabled="(vm.searchText==null || vm.searchText.length < 4)" class="btn btn-default" ui-sref="search({search: vm.searchText})">Suchen</button></form></div></div><div><!-- Marketing Icons Section --><div class="row"><div class="col-lg-12"><div class="well text-center"><i>"Die Welt ist ein Buch. Wer nie reist, sieht nur eine Seite davon."</i> - Aurelius Augustinus (354 - 430)</div></div></div><div class="row"><div ng-if="vm.news.length>0" class="col-md-4"><h3><i class="fa fa-fw fa-check"></i> Aktuelles</h3><div ng-repeat="news in vm.news track by news.id"><ul><li><h4><a class="clean-link" ng-if="news.url!=null" target="_blank" href="{{news.url}}">{{news.title}} </a><span ng-if="news.url==null">{{news.title}}</span></h4>{{news.content}}</li></ul></div></div><!-- /.row --><!-- Features Section --><div class="col-md-4"><h3><i class="fa fa-fw fa-envelope"></i> Newsletter</h3><p>Wenn Sie gerne \xFCber die neuesten Angebote und Ideen f\xFCr ihre Schulausfl\xFCge informiert werden wollen, melden Sie sich f\xFCr unseren Newsletterdienst an.</p><a class="btn btn-default" ui-sref="home.newsletter">Anmelden</a></div><div class="col-md-4"><h3><i class="fa fa-fw fa-compass"></i> Autorenlesung</h3><img class="img-responsive" src="content/images/autorenlesung.png" alt=""><p>Ihnen gef\xE4llt schulausflug.at? Dann k\xF6nnte Sie auch autorenlesung.at interessieren!</p><a target="_blank" class="btn btn-default" href="http://www.autorenlesung.at">Zu autorenlesung.at</a></div></div></div><!-- /.container --><!-- Script to Activate the Carousel --><script>$(\'.carousel\').carousel({\n            interval: 5000 //changes the speed\n        })</script></div>');
$templateCache.put('app/home/newsletter-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNewsLabel">Anmeldung zum Newsletter</h4><div>Wenn Sie gerne \xFCber die neuesten Angebote und Ideen rund um Schulausfl\xFCge informiert werden wollen, melden Sie sich f\xFCr unseren Newsletterdienst an. Wir ben\xF6tigen nur Ihre Emailadresse. Sie k\xF6nnen sich jederzeit auch wieder vom Newsletter abmelden.</div></div><div class="modal-body"><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="email" class="form-control" name="organizerEmail" id="field_email" ng-model="vm.newsletter.email" required maxlength="255"></div><div class="form-group"><input type="checkbox" name="tos" id="field_tos" ng-model="vm.tos"><label for="field_tos">Ich bin einverstanden, dass das Service f\xFCr Jugendkultur Eibl&Eibl meine Daten laut den <a target="_blank" ui-sref="tos">Nutzungsbedingungen</a> verwenden darf.</label></div></div><div class="alert alert-danger" ng-show="vm.error">Anmeldung fehlgeschlagen. Bitte \xFCberpr\xFCfen Sie Ihre Eingaben.</div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" title="{{ editForm.$invalid ? \'Leider sind Ihre Angaben nicht vollst\xE4ndig oder inkorrekt, bitte \xFCberpr\xFCfen Sie die Felder.\' : \'\'}}" ng-disabled="editForm.$invalid || vm.isSaving || !vm.tos" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Anmelden</span></button></div></form>');
$templateCache.put('app/inquiry/inquiry-success.html','<h2>Danke f\xFCr Ihre Anfrage!</h2><p>Sie erhalten in den n\xE4chsten Minuten eine Kopie Ihrer Anfrage per Mail, die evtl. auch im Spamordner landen k\xF6nnte. Bitte kontaktieren Sie uns per Mail, wenn bei Ihnen keine Mail einlangt.</p><br><p>Fritz Eibl, Service f\xFCr Jugendkultur</p>');
$templateCache.put('app/inquiry/inquiry.html','<div><h2>Anfrage an {{vm.company.name}}</h2></div><div ng-if="vm.company.image"><a target="_blank" href="{{vm.company.websiteURL}}"><img class="company-image" data-ng-src="{{\'data:\' + vm.company.imageContentType + \';base64,\' + vm.company.image}}" alt="Generic placeholder thumbnail"></a></div><br><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="field_text">Kontaktanfrage</label><textarea maxlength="255" class="form-control" name="text" id="field_text" ng-model="vm.inquiry.text" required></textarea><div ng-show="editForm.text.$invalid"><p class="help-block" ng-show="editForm.text.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.inquiry.name" ng-maxlength="255" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_phone">Telefon</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.inquiry.phone" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.inquiry.email" required maxlength="255"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_address">Adresse</label><input type="text" class="form-control" name="phone" id="field_address" ng-model="vm.inquiry.address" ng-maxlength="255"></div><div class="form-group"><input type="checkbox" name="tos" id="field_tos" ng-model="vm.tos"><label for="field_tos">Ich bin einverstanden, dass das Service f\xFCr Jugendkultur Eibl&Eibl meine Daten laut den <a target="_blank" ui-sref="tos">Nutzungsbedingungen</a> verwenden darf.</label></div><div class="alert alert-danger" ng-show="vm.error">Anfrage fehlgeschlagen. Bitte \xFCberpr\xFCfen Sie Ihre Eingaben.</div><div class="tooltip-wrapper"><button type="submit" title="{{ editForm.$invalid ? \'Leider sind Ihre Angaben nicht vollst\xE4ndig oder inkorrekt, bitte \xFCberpr\xFCfen Sie die Felder.\' : \'\'}}" ng-disabled="editForm.$invalid || vm.isSaving || !vm.tos" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Absenden</span></button></div></form>');
$templateCache.put('app/tos/tos.html','<div><h3>Nutzungsbedingungen und Erkl\xE4rung zur Informationspflicht</h3><h4>Datenschutzerkl\xE4rung</h4>Der Schutz Ihrer pers\xF6nlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschlie\xDFlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In diesen Datenschutzinformationen informieren wir Sie \xFCber die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.<h4>Kontakt mit uns / Datenspeicherung</h4>Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns und unseren gelisteten Betrieben aufnehmen, werden Ihre angegebenen Daten (Mailadresse, Name) zwecks Bearbeitung der Anfrage und f\xFCr den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.\xA0Die bei uns gelisteten Betriebe sind f\xFCr die Einhaltung der Richtlinien der Datenschutzgrundverordnung selbst verantwortlich.<h4>Cookies</h4>Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um kleine Textdateien, die mit Hilfe des Browsers auf Ihrem Endger\xE4t abgelegt werden. Sie richten keinen Schaden an. Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben auf Ihrem Endger\xE4t gespeichert, bis Sie diese l\xF6schen. Sie erm\xF6glichen es uns, Ihren Browser beim n\xE4chsten Besuch wiederzuerkennen. Wenn Sie dies nicht w\xFCnschen, so k\xF6nnen Sie Ihren Browser so einrichten, dass er Sie \xFCber das Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben. Bei der Deaktivierung von Cookies kann die Funktionalit\xE4t unserer Website eingeschr\xE4nkt sein.<h4>Web-Analyse</h4>Unsere Website verwendet Funktionen des Webanalysedienstes google analytics, ein Dienst der Google Inc, 1600 Amphitheatre Parkway Mountain View, CA 94043, USA; die Daten werden an ein au\xDFereurop\xE4isches Drittland \xFCbertragen. Dazu werden Cookies verwendet, die eine Analyse der Benutzung der Website durch Ihre Benutzer erm\xF6glicht. Die dadurch erzeugten Informationen werden auf den Server des Anbieters \xFCbertragen und dort gespeichert. Die Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des \xA7 96 Abs 3 TKG sowie des Art 6 Abs 1 lit a (Einwilligung) und/oder f (berechtigtes Interesse) der DSGVO.<h4>Newsletter</h4>Sie haben die M\xF6glichkeit, \xFCber unsere Website unseren Newsletter zu abonnieren. Hierf\xFCr ben\xF6tigen wir Ihre E-Mail-Adresse und ihre Erkl\xE4rung, dass Sie mit dem Bezug des Newsletters einverstanden sind. Das Abo des Newsletters k\xF6nnen Sie jederzeit stornieren. Senden Sie Ihre Stornierung bitte an folgende E-Mail-Adresse: f.eibl@schulausflug.at. Wir l\xF6schen anschlie\xDFend umgehend Ihre Daten im Zusammenhang mit dem Newsletter-Versand.<h4>Ihre Rechte</h4>Ihnen stehen grunds\xE4tzlich die Rechte auf Auskunft, Berichtigung, L\xF6schung, Einschr\xE4nkung, Daten\xFCbertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verst\xF6\xDFt oder Ihre datenschutzrechtlichen Anspr\xFCche sonst in einer Weise verletzt worden sind, k\xF6nnen Sie sich bei der Aufsichtsbeh\xF6rde beschweren. In \xD6sterreich ist dies die Datenschutzbeh\xF6rde.\xA0 Sie erreichen uns unter folgenden Kontaktdaten:<br><br>Service f\xFCr Jugendkultur Eibl&Eibl, 0043 664 521 80 88; f.eibl@schulausflug.at</div>');
$templateCache.put('app/user-company/user-companies.html','<div ng-if="vm.state"><div class="text-center"><span ng-repeat=" state in vm.states"><button class="filter-button" type="submit" ui-sref="{{vm.type | lowercase}}({bl:state.id, sk: null})">{{state.name}} <i class="fa fa-check-circle" ng-if="state.id==vm.state"></i></button></span></div></div><h3 class="text-center">{{vm.type | categoryPlural}} <span ng-if="vm.state">in {{vm.getStateName()}}</span></h3><div ng-if="vm.state && vm.type==\'DAYTRIP\'"><div class="text-center"><span ng-repeat=" subCategory in vm.subCategories"><button class="filter-button" type="submit" ui-sref="{{vm.type | lowercase}}({bl:vm.state, sk: subCategory})">{{subCategory | subcategory}} <i class="fa fa-check-circle" ng-if="subCategory==vm.subCategory"></i></button></span></div><br></div><div ng-if="!vm.companies"><div class="text-center"><span>In welchem Bundesland m\xF6chten Sie suchen?</span><br><br><div class="row"><div class="col-sm-4" ng-repeat="state in vm.states"><div class="filter-banner"><a class="clean-link" ui-sref="{{vm.type | lowercase}}({bl:state.id})"><img class="filter-image" data-ng-src="{{\'data:\' + state.imageContentType + \';base64,\' + state.image}}"></a></div><div class="filter-banner-text"><a class="clean-link" ui-sref="{{vm.type | lowercase}}({bl:state.id})"><h4>{{state.name }}</h4></a></div></div></div></div></div><div ng-if="vm.companies"><div ng-if="vm.companies.length==0 && !busy">Keine Ergebnisse vorhanden</div><div infinite-scroll="vm.loadNextCompaniesPage()" infinite-scroll-distance="1" infinite-scroll-disabled="!vm.hasNextPage || busy"><div class="row"><!--TODO: extract this to directive and use below --><!--Currently not implemented as infinite scroll does not work anymore then--><!--(Immediately loads 2 pages)--><div class="col-sm-6" ng-repeat=" company in vm.companies"><div class="company-box"><a class="clean-link" target="_blank" href="{{company.websiteURL}}"><h4>{{company.name}}</h4></a><div class="row"><div class="col-sm-5 image-box"><div ng-if="company.image"><a target="_blank" href="{{company.websiteURL}}"><img class="company-image" data-ng-src="{{\'data:\' + company.imageContentType + \';base64,\' + company.image}}" alt="Generic placeholder thumbnail"></a></div></div><div class="col-sm-4 contact-box">{{company.city}}<br>{{company.phone}}<br><a ng-if="company.email" class="clean-link icon" ui-sref="inquiry({company: company, id: company.id})"><i class="fa fa-envelope-square"></i> </a><a ng-if="company.facebookURL" target="_blank" class="clean-link icon" href="{{company.facebookURL}}"><i class="fa fa-facebook-square"></i></a><br><span ng-if="company.minAge!=null" class="badge" title="Altersangabe">ab {{company.minAge}} - 99</span> <i ng-if="company.barrierFree" class="fa fa-wheelchair icon" title="Barrierefrei"></i></div><div class="col-sm-3 image-box"><ui-gmap-google-map center="mapCenters[company.id]" zoom="mapZoom" options="mapOptions"><ui-gmap-markers data-models="mapMarkers[company.id]" data-coords="\'coords\'"></ui-gmap-markers></ui-gmap-google-map></div></div><div class="row"><div class="col-sm-12 text-box"><span class="image-text">{{company.imageText}}</span></div></div></div></div></div></div><div ng-if="vm.adjacent_companies.length > 0"><h4 class="text-center">Angrenzende Betriebe</h4><div class="row"><div infinite-scroll="vm.loadNextAdjacentCompaniesPage()" infinite-scroll-distance="1" infinite-scroll-disabled="!vm.hasNextAdjacentPage || busy"><div class="col-sm-6" ng-repeat=" company in vm.adjacent_companies"><div class="company-box"><a class="clean-link" target="_blank" href="{{company.websiteURL}}"><h4>{{company.name}}</h4></a><div class="row"><div class="col-sm-5 image-box"><div ng-if="company.image"><a target="_blank" href="{{company.websiteURL}}"><img class="company-image" data-ng-src="{{\'data:\' + company.imageContentType + \';base64,\' + company.image}}" alt="Generic placeholder thumbnail"></a></div></div><div class="col-sm-4 contact-box">{{company.city}}<br>{{company.phone}}<br><a ng-if="company.email" class="clean-link icon" ui-sref="inquiry({company: company, id: company.id})"><i class="fa fa-envelope-square"></i> </a><a ng-if="company.facebookURL" target="_blank" class="clean-link icon" href="{{company.facebookURL}}"><i class="fa fa-facebook-square"></i></a><br><span ng-if="company.minAge!=null" class="badge" title="Altersangabe">ab {{company.minAge}} - 99</span> <i ng-if="company.barrierFree" class="fa fa-wheelchair icon" title="Barrierefrei"></i></div><div class="col-sm-3 image-box"><ui-gmap-google-map center="mapCenters[company.id]" zoom="mapZoom" options="mapOptions"><ui-gmap-markers data-models="mapMarkers[company.id]" data-coords="\'coords\'"></ui-gmap-markers></ui-gmap-google-map></div></div><div class="row"><div class="col-sm-12 text-box"><span class="image-text">{{company.imageText}}</span></div></div></div></div></div></div></div></div>');
$templateCache.put('app/user-company/user-company-result.html','<div ng-if="vm.companies"><div ng-if="vm.companies.length==0 && !busy">Keine Ergebnisse vorhanden</div><!--<div infinite-scroll="vm.loadNextCompaniesPage()" infinite-scroll-distance="1" infinite-scroll-disabled="!vm.hasNextPage || busy">--><div><div class="row"><!--TODO: extract this to directive and use below --><!--Currently not implemented as infinite scroll does not work anymore then--><!--(Immediately loads 2 pages)--><div class="col-sm-6" ng-repeat=" company in vm.companies"><div class="company-box"><a class="clean-link" target="_blank" href="{{company.websiteURL}}"><h4>{{company.name}}</h4></a><div class="row"><div class="col-sm-5 image-box"><div ng-if="company.image"><a target="_blank" href="{{company.websiteURL}}"><img class="company-image" data-ng-src="{{\'data:\' + company.imageContentType + \';base64,\' + company.image}}" alt="Generic placeholder thumbnail"></a></div></div><div class="col-sm-4 contact-box">{{company.city}}<br>{{company.phone}}<br><a ng-if="company.email" class="clean-link icon" ui-sref="inquiry({id: company.id, company: company})"><i class="fa fa-envelope-square"></i> </a><a ng-if="company.facebookURL" target="_blank" class="clean-link icon" href="{{company.facebookURL}}"><i class="fa fa-facebook-square"></i></a><br><span ng-if="company.minAge!=null" class="badge" title="Altersangabe">ab {{company.minAge}} - 99</span> <i ng-if="company.barrierFree" class="fa fa-wheelchair icon" title="Barrierefrei"></i></div><div class="col-sm-3 image-box"><ui-gmap-google-map center="mapCenters[company.id]" zoom="mapZoom" options="mapOptions"><ui-gmap-markers data-models="mapMarkers[company.id]" data-coords="\'coords\'"></ui-gmap-markers></ui-gmap-google-map></div></div><div class="row"><div class="col-sm-12 text-box"><span class="image-text">{{company.imageText}}</span></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length === 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length === 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3>Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Cache name</th><th class="text-right">Cache Hits</th><th class="text-right">Cache Misses</th><th class="text-right">Cache Gets</th><th class="text-right">Cache Puts</th><th class="text-right">Cache Removals</th><th class="text-right">Cache Evictions</th><th class="text-right">Cache Hit %</th><th class="text-right">Cache Miss %</th><th class="text-right">Average get time (\xB5s)</th><th class="text-right">Average put time (\xB5s)</th><th class="text-right">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span>User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span>Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated">Activated</span></dd><dt><span>First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span>Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span>Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">Dieses Feld ist verpflichtend.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">Dieses Feld ist verpflichtend.</p><p class="help-block" ng-show="editForm.email.$error.email">Email ung\xFCltig</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span>Activated</span></label></div><div class="form-group"><label>Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2>Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th><span>Profiles</span></th><th jh-sort-by="createdDate"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login">Activated</button></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Your email" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Anmelden</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Anmelden</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError"><strong>Fehler beim Anmelden!</strong></div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username">Benutzername</label><input type="text" class="form-control" id="username" placeholder="Benutzername" ng-model="vm.username"></div><div class="form-group"><label for="password">Passwort</label><input type="password" class="form-control" id="password" placeholder="Passwort" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span>Anmeldeinformationen merken</span></label></div><button type="submit" class="btn btn-primary">Anmelden</button></form></div></div></div>');
$templateCache.put('app/entities/company/companies.html','<div><h2>Betriebe</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="company.new"><span class="glyphicon glyphicon-plus"></span> <span>Neuen Betrieb erstellen</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="stateId"><span>Bundesland</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="city"><span>Ort</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="category"><span>Kategorie</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="subCategory"><span>Subkategorie</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="position"><span>Position</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span>Aktiv</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="image"><span>Bild</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="imageText"><span>Imagetext</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="zip"><span>PLZ</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="country"><span>Land</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="streetName"><span>Stra\xDFe</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="streetNumber"><span>Stra\xDFennummer</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="phone"><span>Telefon</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="websiteURL"><span>Website</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="facebookURL"><span>Facebook</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="barrierFree"><span>Barrierefrei</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="notes"><span>Notizen</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="contactName"><span>Ansprechperson - Name</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="contactPhone"><span>Ansprechperson - Telefon</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="contactEmail"><span>Ansprechperson - Email</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat="company in vm.companies track by company.id"><td>{{company.name}}</td><td>{{company.stateName}}</td><td>{{company.city}}</td><td>{{company.category | category}}</td><td>{{company.subCategory | subcategory}}</td><td>{{company.position}}</td><td>{{company.active | checkmark}}</td><!--<td>--><!--<a ng-if="company.image" ng-click="vm.openFile(company.imageContentType, company.image)">--><!--<img data-ng-src="{{\'data:\' + company.imageContentType + \';base64,\' + company.image}}" style="max-height: 30px;" alt="company image"/>--><!--</a>--><!--<span ng-if="company.image">{{company.imageContentType}}, {{vm.byteSize(company.image)}}</span>--><!--</td>--><!--<td>{{company.imageText}}</td>--><!--<td>{{company.zip}}</td>--><!--<td>{{company.country}}</td>--><!--<td>{{company.streetName}}</td>--><!--<td>{{company.streetNumber}}</td>--><!--<td>{{company.phone}}</td>--><!--<td>{{company.websiteURL}}</td>--><!--<td>{{company.facebookURL}}</td>--><!--<td>{{company.barrierFree}}</td>--><!--<td>{{company.notes}}</td>--><!--<td>{{company.contactName}}</td>--><!--<td>{{company.contactPhone}}</td>--><!--<td>{{company.contactEmail}}</td>--><!--<td>{{company.email}}</td>--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="company-detail({id:company.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="company.edit({id:company.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="company.delete({id:company.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/company/company-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.company.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Diesen Betrieb wirklich l\xF6schen? Es werden dadurch auch alle Vertr\xE4ge (inklusive Rechnungen) des Betriebs gel\xF6scht.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/company/company-detail.html','<div><h2>{{vm.company.name}}</h2><button type="submit" ui-sref="company" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Zur\xFCck</span></button> <button type="button" ui-sref="company-detail.edit({id:vm.company.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Bearbeiten</span></button><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.company.name}}</span></dd><dt><span>Bild</span></dt><dd><div ng-if="vm.company.image"><a ng-click="vm.openFile(vm.company.imageContentType, vm.company.image)"><img data-ng-src="{{\'data:\' + vm.company.imageContentType + \';base64,\' + vm.company.image}}" style="max-width: 100%" alt="company image"> </a>{{vm.company.imageContentType}}, {{vm.byteSize(vm.company.image)}}</div></dd><dt><span>Imagetext</span></dt><dd><span>{{vm.company.imageText}}</span></dd><dt><span>Bundesland</span></dt><dd><span>{{vm.company.stateName}}</span></dd><dt><span>Angrenz. Bundesl\xE4nder</span></dt><dd><span ng-repeat="adjacentStateId in vm.company.adjacentStateIds">{{vm.stateNameById(adjacentStateId)}}{{$last ? \'\' : \', \'}}</span></dd><dt><span>Kategorie</span></dt><dd><span>{{vm.company.category | category}}</span></dd><dt><span>Subkategorie</span></dt><dd><span>{{vm.company.subCategory | subcategory}}</span></dd><dt><span>Barrierefrei</span></dt><dd><span>{{vm.company.barrierFree | checkmark}}</span></dd><dt><span>Mindestalter</span></dt><dd><span>{{vm.company.minAge}}</span></dd><dt><span>Notizen</span></dt><dd><span>{{vm.company.notes}}</span></dd><dt><span>Position</span></dt><dd><span>{{vm.company.position}}</span></dd><dt><span>Aktiv</span></dt><dd><span>{{vm.company.active | checkmark}}</span></dd><h4>Kontaktdaten</h4><dt><span>Email</span></dt><dd><span>{{vm.company.email}}</span></dd><dt><span>PLZ</span></dt><dd><span>{{vm.company.zip}}</span></dd><dt><span>Land</span></dt><dd><span>{{vm.company.country}}</span></dd><dt><span>Stra\xDFe</span></dt><dd><span>{{vm.company.streetName}}</span></dd><dt><span>Stra\xDFennummer</span></dt><dd><span>{{vm.company.streetNumber}}</span></dd><dt><span>Stadt</span></dt><dd><span>{{vm.company.city}}</span></dd><dt><span>L\xE4ngengrad</span></dt><dd><span>{{vm.company.longitude}}</span></dd><dt><span>Breitengrad</span></dt><dd><span>{{vm.company.latitude}}</span></dd><dt><span>Telefon</span></dt><dd><span>{{vm.company.phone}}</span></dd><dt><span>Webseite (URL)</span></dt><dd><span>{{vm.company.websiteURL}}</span></dd><dt><span>Facebook (URL)</span></dt><dd><span>{{vm.company.facebookURL}}</span></dd><h4>Ansprechperson</h4><dt><span>Name</span></dt><dd><span>{{vm.company.contactName}}</span></dd><dt><span>Telefon</span></dt><dd><span>{{vm.company.contactPhone}}</span></dd><dt><span>Email</span></dt><dd><span>{{vm.company.contactEmail}}</span></dd></dl><h3>Vertr\xE4ge</h3><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="company-detail.new-contract({id:vm.company.id})"><span class="glyphicon glyphicon-plus"></span> <span>Neuen Vertrag erstellen</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="startDate"><span>Startdatum</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endDate"><span>Enddatum</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="notes"><span>Notizen</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="yearlyFee"><span>Jahresgeb\xFChr (\u20AC)</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="recipientCompanyName"><span>Empf\xE4nger - Firma</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientName"><span>Empf\xE4nger - Name</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientZip"><span>Empf\xE4nger - PLZ</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientCountry"><span>Empf\xE4nger - Land</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientStreetName"><span>Empf\xE4nger - Stra\xDFe</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientStreetNumber"><span>Empf\xE4nger - Stra\xDFennummer</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientCity"><span>Empf\xE4nger - Ort</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientEmail"><span>Empf\xE4nger - Email</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="invoiceDate"><span>Rechnungsdatum</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="contract in vm.company.contracts track by contract.id"><td>{{contract.startDate | date:\'d. MMM yyyy, HH:mm\'}}</td><td>{{contract.endDate | date:\'d. MMM yyyy, HH:mm\'}}</td><!--<td>{{contract.notes}}</td>--><td>{{contract.yearlyFee}}</td><!--<td>{{contract.recipientCompanyName}}</td>--><!--<td>{{contract.recipientName}}</td>--><!--<td>{{contract.recipientZip}}</td>--><!--<td>{{contract.recipientCountry}}</td>--><!--<td>{{contract.recipientStreetName}}</td>--><!--<td>{{contract.recipientStreetNumber}}</td>--><!--<td>{{contract.recipientCity}}</td>--><!--<td>{{contract.recipientEmail}}</td>--><td>{{contract.invoiceDate | date:\'d. MMM\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="contract-detail({id:contract.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="company-detail.new-contract({id:contract.companyId, base_contract: contract})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-duplicate"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="company-detail.edit-contract({id:contract.companyId, contract_id: contract.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="company-detail.delete-contract({id:contract.companyId, contract_id:contract.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/company/company-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCompanyLabel">Betrieb erstellen oder bearbeiten</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.company.name" required ng-maxlength="255"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImage($file, vm.company)" ngf-pattern="\'image/*\'"><label class="control-label" for="field_image">Bild</label><div><img data-ng-src="{{\'data:\' + vm.company.imageContentType + \';base64,\' + vm.company.image}}" style="max-height: 100px" ng-if="vm.company.image" alt="company image"><div ng-if="vm.company.image" class="help-block clearfix"><span class="pull-left">{{vm.company.imageContentType}}, {{vm.byteSize(vm.company.image)}}</span> <button type="button" ng-click="vm.company.image=null;vm.company.imageContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImage($file, vm.company)" accept="image/*">Bild hinzuf\xFCgen</button></div><input type="hidden" class="form-control" name="image" id="field_image" ng-model="vm.company.image"> <input type="hidden" class="form-control" name="imageContentType" id="field_imageContentType" ng-model="vm.company.imageContentType"></div><div class="form-group"><label class="control-label" for="field_imageText">Imagetext</label><textarea maxlength="300" class="form-control" name="imageText" id="field_imageText" ng-model="vm.company.imageText"></textarea><div ng-show="editForm.imageText.$invalid"><p ng-show="editForm.imageText.$error.maxlength" class="help-block">Maximal 300 Zeichen</p></div></div><div class="form-group"><label for="field_state">Bundesland</label><select class="form-control" id="field_state" name="state" ng-model="vm.company.stateId" ng-options="state.id as state.name for state in vm.states"><option value=""></option></select></div><div class="form-group"><label for="field_adjacentStates">Angrenzende Bundesl\xE4nder</label><select class="form-control" id="field_adjacentStates" multiple="multiple" name="adjacentStates" ng-model="vm.company.adjacentStateIds" ng-options="state.id as state.name for state in vm.states"></select></div><div class="form-group"><label class="control-label" for="field_category">Kategorie</label><select class="form-control" name="category" required ng-model="vm.company.category" id="field_category"><option value="DAYTRIP">Tagesausflug</option><option value="ACCOMMODATION">Projekttage/Projektwochen</option><option value="BUSCOMPANY">Busunternehmen</option></select><div ng-show="editForm.category.$invalid"><p class="help-block" ng-show="editForm.category.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_subCategory">Subkategorie</label><select class="form-control" name="subCategory" ng-model="vm.company.subCategory" id="field_subCategory"><option value="OUTDOOR">Outdoor</option><option value="WINTER">Winter</option><option value="ALLWEATHERS">Bei jedem Wetter</option></select></div><div class="form-group"><label class="control-label" for="field_barrierFree">Barrierefrei</label><input type="checkbox" name="barrierFree" id="field_barrierFree" ng-model="vm.company.barrierFree"></div><div class="form-group"><label class="control-label" for="field_minAge">Mindestalter</label><input type="number" step="1" name="minAge" id="field_minAge" ng-model="vm.company.minAge"></div><div class="form-group"><label class="control-label" for="field_notes">Notizen</label><textarea class="form-control" name="notes" id="field_notes" ng-model="vm.company.notes"></textarea></div><div class="form-group"><label class="control-label" for="field_position">Position</label><input type="number" class="form-control" name="position" id="field_position" ng-model="vm.company.position"></div><div class="form-group"><label class="control-label" for="field_active">Aktiv</label><input type="checkbox" name="active" id="field_active" ng-model="vm.company.active"></div><h4>Kontaktdaten</h4><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.company.email" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_zip">PLZ</label><input type="text" class="form-control" name="zip" id="field_zip" ng-model="vm.company.zip" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_country">Land</label><input type="text" class="form-control" name="country" id="field_country" ng-model="vm.company.country" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_streetName">Stra\xDFe</label><input type="text" class="form-control" name="streetName" id="field_streetName" ng-model="vm.company.streetName" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_streetNumber">Stra\xDFennummer</label><input type="text" class="form-control" name="streetNumber" id="field_streetNumber" ng-model="vm.company.streetNumber" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_city">Ort</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.company.city" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_longitude">L\xE4ngengrad</label><input type="number" step="any" class="form-control" name="longitude" id="field_longitude" required ng-model="vm.company.longitude"><div ng-show="editForm.longitude.$invalid"><p class="help-block" ng-show="editForm.longitude.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_latitude">Breitengrad</label><input type="number" step="any" class="form-control" name="latitude" id="field_latitude" required ng-model="vm.company.latitude"><div ng-show="editForm.latitude.$invalid"><p class="help-block" ng-show="editForm.latitude.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_phone">Telefon</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.company.phone" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_websiteURL">Website (URL, mit http://)</label><input type="text" class="form-control" name="websiteURL" id="field_websiteURL" ng-model="vm.company.websiteURL" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_facebookURL">Facebook (URL, mit http://)</label><input type="text" class="form-control" name="facebookURL" id="field_facebookURL" ng-model="vm.company.facebookURL" ng-maxlength="255"></div><h4>Ansprechperson</h4><div class="form-group"><label class="control-label" for="field_contactName">Name</label><input type="text" class="form-control" name="contactName" id="field_contactName" ng-model="vm.company.contactName" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_contactPhone">Telefon</label><input type="text" class="form-control" name="contactPhone" id="field_contactPhone" ng-model="vm.company.contactPhone" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_contactEmail">Email</label><input type="text" class="form-control" name="contactEmail" id="field_contactEmail" ng-model="vm.company.contactEmail" ng-maxlength="255"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></div></form>');
$templateCache.put('app/entities/contract/contract-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.contract.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Diesen Vertrag wirklich l\xF6schen? Es werden dadurch auch alle Rechnungen des Vertrags gel\xF6scht.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/contract/contract-detail.html','<div><h2><span>Vertrag -</span> {{vm.contract.companyName}} ({{vm.contract.startDate | date:\'yyyy\'}} - {{vm.contract.endDate | date:\'yyyy\'}})</h2><button type="submit" ui-sref="company-detail({id: vm.contract.companyId})" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Zur\xFCck</span></button> <button type="button" ui-sref="contract-detail.edit({contract_id:vm.contract.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Bearbeiten</span></button><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Startdatum</span></dt><dd><span>{{vm.contract.startDate | date:\'d. MMM yyyy, HH:mm\'}}</span></dd><dt><span>Enddatum</span></dt><dd><span>{{vm.contract.endDate | date: \'d. MMM yyyy, HH:mm\'}}</span></dd><dt><span>1. Rechnungsdatum</span></dt><dd><span>{{vm.contract.invoiceDate | date:\'d. MMM yyyy, HH:mm\'}}</span></dd><dt><span>Jahresgeb\xFChr (\u20AC)</span></dt><dd><span>{{vm.contract.yearlyFee}}</span></dd><dt><span>Notizen</span></dt><dd><span>{{vm.contract.notes}}</span></dd><h4>Empf\xE4nger</h4><dt><span>Firma</span></dt><dd><span>{{vm.contract.recipientCompanyName}}</span></dd><dt><span>Vorname</span></dt><dd><span>{{vm.contract.recipientFirstName}}</span></dd><dt><span>Nachname</span></dt><dd><span>{{vm.contract.recipientLastName}}</span></dd><dt><span>Geschlecht</span></dt><dd><span>{{vm.contract.recipientGender | gender}}</span></dd><dt><span>Name auf Rechnung</span></dt><dd><span>{{vm.company.recipientNameOnInvoice | checkmark}}</span></dd><dt><span>PLZ</span></dt><dd><span>{{vm.contract.recipientZip}}</span></dd><dt><span>Land</span></dt><dd><span>{{vm.contract.recipientCountry}}</span></dd><dt><span>Stra\xDFe</span></dt><dd><span>{{vm.contract.recipientStreetName}}</span></dd><dt><span>Stra\xDFennummer</span></dt><dd><span>{{vm.contract.recipientStreetNumber}}</span></dd><dt><span>Ort</span></dt><dd><span>{{vm.contract.recipientCity}}</span></dd><dt><span>Email</span></dt><dd><span>{{vm.contract.recipientEmail}}</span></dd></dl><h3>Rechnungen</h3><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="contract-detail.new-invoice({id:vm.contract.id})"><span class="glyphicon glyphicon-plus"></span> <span>Neue Rechnung erstellen</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Rechnungsnummer</span></th><!--<th><span>Notiz</span></th>--><th><span>Datum</span></th><th><span>Preis (\u20AC)</span></th><th><span>Firma (Empf.)</span></th><th><span>Name (Empf.)</span></th><!--<th><span>Empf\xE4nger - PLZ</span></th>--><!--<th><span>Empf\xE4nger - Land</span></th>--><!--<th><span>Empf\xE4nger - Stra\xDFe</span></th>--><!--<th><span>Empf\xE4nger - Stra\xDFennummer</span></th>--><!--<th><span>Empf\xE4nger - Ort</span></th>--><!--<th><span>Empf\xE4nger - Email</span></th>--><th><span>Gesendet</span></th><th></th></tr></thead><tbody><tr ng-repeat="invoice in vm.contract.invoices track by invoice.id"><td>{{invoice.invoiceId}}</td><!--<td>{{invoice.notes}}</td>--><td>{{invoice.date | date:\'d. MMM yyyy\'}}</td><td>{{invoice.fee}}</td><td>{{invoice.recipientCompanyName}}</td><td>{{invoice.recipientLastName}}</td><!--<td>{{invoice.recipientZip}}</td>--><!--<td>{{invoice.recipientCountry}}</td>--><!--<td>{{invoice.recipientStreetName}}</td>--><!--<td>{{invoice.recipientStreetNumber}}</td>--><!--<td>{{invoice.recipientCity}}</td>--><!--<td>{{invoice.recipientEmail}}</td>--><td>{{invoice.issued | date:\'d. MMM yyyy, HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="invoice-detail({id: invoice.id, invoice_id:invoice.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ng-disabled="invoice.invoiceId == undefined || invoice.invoiceId.length == 0" ng-click="vm.downloadPDF(invoice.id)" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-save"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="contract-detail.edit-invoice({contract_id: invoice.contractId , invoice_id:invoice.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ng-disabled="invoice.invoiceId == undefined || invoice.invoiceId.length == 0 || invoice.issued != undefined" ui-sref="contract-detail.send-invoice({contract_id: invoice.contractId, invoice_id:invoice.id})" class="btn btn-warning btn-sm"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="contract-detail.delete-invoice({contract_id: invoice.contractId, invoice_id:invoice.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/contract/contract-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myContractLabel">Vertrag erstellen oder bearbeiten</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_startDate">Startdatum</label><div class="input-group"><input id="field_startDate" type="text" required class="form-control" name="startDate" datetime-picker="{{dateformat}}" ng-model="vm.contract.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.startDate.$invalid"><p class="help-block" ng-show="editForm.startDate.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_endDate">Enddatum</label><div class="input-group"><input id="field_endDate" type="text" required class="form-control" name="endDate" datetime-picker="{{dateformat}}" ng-model="vm.contract.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.endDate.$invalid"><p class="help-block" ng-show="editForm.endDate.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_invoiceDate">1. Rechnungsdatum</label><div class="input-group"><input id="field_invoiceDate" type="text" required class="form-control" name="invoiceDate" datetime-picker="{{dateformat}}" ng-model="vm.contract.invoiceDate" is-open="vm.datePickerOpenStatus.invoiceDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'invoiceDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.invoiceDate.$invalid"><p class="help-block" ng-show="editForm.invoiceDate.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_yearlyFee">Jahresgeb\xFChr (\u20AC)</label><input type="number" required class="form-control" name="yearlyFee" id="field_yearlyFee" ng-model="vm.contract.yearlyFee"><div ng-show="editForm.yearlyFee.$invalid"><p class="help-block" ng-show="editForm.yearlyFee.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_notes">Notizen</label><textarea class="form-control" name="notes" id="field_notes" ng-model="vm.contract.notes"></textarea></div><h4>Empf\xE4nger</h4><div class="form-group"><label class="control-label" for="field_recipientCompanyName">Firma</label><input type="text" class="form-control" name="recipientCompanyName" id="field_recipientCompanyName" ng-model="vm.contract.recipientCompanyName" ng-maxlength="255" required><div ng-show="editForm.recipientCompanyName.$invalid"><p class="help-block" ng-show="editForm.recipientCompanyName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientFirstName">Vorname</label><input type="text" class="form-control" name="recipientFirstName" id="field_recipientFirstName" ng-model="vm.contract.recipientFirstName" ng-maxlength="255" required><div ng-show="editForm.recipientFirstName.$invalid"><p class="help-block" ng-show="editForm.recipientFirstName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientLastName">Nachname</label><input type="text" class="form-control" name="recipientLastName" id="field_recipientLastName" ng-model="vm.contract.recipientLastName" ng-maxlength="255" required><div ng-show="editForm.recipientLastName.$invalid"><p class="help-block" ng-show="editForm.recipientLastName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientGender">Geschlecht</label><select class="form-control" name="recipientGender" ng-model="vm.contract.recipientGender" id="field_recipientGender" required><option value="MALE">M\xE4nnlich</option><option value="FEMALE">Weiblich</option></select><div ng-show="editForm.recipientGender.$invalid"><p class="help-block" ng-show="editForm.recipientGender.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientNameOnInvoice">Vor- und Nachname auf Rechnung</label><input type="checkbox" name="recipientNameOnInvoice" id="field_recipientNameOnInvoice" ng-model="vm.invoice.recipientNameOnInvoice"></div><div class="form-group"><label class="control-label" for="field_recipientZip">PLZ</label><input type="text" required class="form-control" name="recipientZip" id="field_recipientZip" ng-model="vm.contract.recipientZip" ng-maxlength="255"><div ng-show="editForm.recipientZip.$invalid"><p class="help-block" ng-show="editForm.recipientZip.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientCountry">Land</label><input type="text" class="form-control" name="recipientCountry" id="field_recipientCountry" ng-model="vm.contract.recipientCountry" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_recipientStreetName">Stra\xDFe</label><input type="text" required class="form-control" name="recipientStreetName" id="field_recipientStreetName" ng-model="vm.contract.recipientStreetName" ng-maxlength="255"><div ng-show="editForm.recipientStreetName.$invalid"><p class="help-block" ng-show="editForm.recipientStreetName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientStreetNumber">Stra\xDFennummer</label><input type="text" required class="form-control" name="recipientStreetNumber" id="field_recipientStreetNumber" ng-model="vm.contract.recipientStreetNumber" ng-maxlength="255"><div ng-show="editForm.recipientStreetNumber.$invalid"><p class="help-block" ng-show="editForm.recipientStreetNumber.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientCity">Ort</label><input type="text" required class="form-control" name="recipientCity" id="field_recipientCity" ng-model="vm.contract.recipientCity" ng-maxlength="255"><div ng-show="editForm.recipientCity.$invalid"><p class="help-block" ng-show="editForm.recipientCity.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientEmail">Email</label><input type="email" class="form-control" name="recipientEmail" id="field_recipientEmail" ng-model="vm.contract.recipientEmail" required ng-maxlength="255"><div ng-show="editForm.recipientEmail.$invalid"><p class="help-block" ng-show="editForm.recipientEmail.$error.required">Dieses Feld ist verpflichtend.</p><p class="help-block" ng-show="editForm.recipientEmail.$error.email">Email ung\xFCltig.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></div></form>');
$templateCache.put('app/entities/contract/contracts.html','<div><h2>Vertr\xE4ge</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="companyId"><span>Betrieb</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="startDate"><span>Startdatum</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endDate"><span>Enddatum</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="notes"><span>Notizen</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="yearlyFee"><span>Jahresgeb\xFChr (\u20AC)</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="recipientCompanyName"><span>Firma (Empf.)</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="recipientLastName"><span>Name (Empf.)</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="recipientZip"><span>Empf\xE4nger - PLZ</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientCountry"><span>Empf\xE4nger - Land</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientStreetName"><span>Empf\xE4nger - Stra\xDFe</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientStreetNumber"><span>Empf\xE4nger - Stra\xDFennummer</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientCity"><span>Empf\xE4nger - Ort</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="recipientEmail"><span>Empf\xE4nger - Email</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="invoiceDate"><span>Rechungsdatum</span> <span class="glyphicon glyphicon-sort"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat="contract in vm.contracts track by contract.id"><td><a ui-sref="company-detail({id:contract.companyId})">{{contract.companyName}}</a></td><!--<td><a ui-sref="contract-detail({id:contract.id})">{{contract.id}}</a></td>--><td>{{contract.startDate | date:\'d. MMM yyyy\'}}</td><td>{{contract.endDate | date:\'d. MMM yyyy\'}}</td><!--<td>{{contract.notes}}</td>--><td>{{contract.yearlyFee}}</td><td>{{contract.recipientCompanyName}}</td><td>{{contract.recipientLastName}}</td><!--<td>{{contract.recipientZip}}</td>--><!--<td>{{contract.recipientCountry}}</td>--><!--<td>{{contract.recipientStreetName}}</td>--><!--<td>{{contract.recipientStreetNumber}}</td>--><!--<td>{{contract.recipientCity}}</td>--><!--<td>{{contract.recipientEmail}}</td>--><!--<td>{{contract.invoiceDate | date:\'medium\'}}</td>--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="contract-detail({id:contract.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="contract.edit({id:contract.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="contract.delete({id:contract.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/invoice/invoice-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.invoice.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Diesen Rechnung wirklich l\xF6schen?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/invoice/invoice-detail.html','<div><h2><span>Rechnung</span> {{vm.invoice.invoiceId}}</h2><button type="submit" ui-sref="contract-detail({id: vm.invoice.contractId})" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Zur\xFCck</span></button> <button type="button" ui-sref="invoice-detail.edit({id:vm.invoice.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Bearbeiten</span></button> <button type="button" ng-disabled="vm.invoice.invoiceId == undefined || vm.invoice.invoiceId.length == 0" ng-click="vm.downloadPDF(vm.invoice.id)" class="btn btn-success"><span class="glyphicon glyphicon-save"></span> <span class="hidden-sm-down">PDF generieren</span></button><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Rechnungsnummer</span></dt><dd><span>{{vm.invoice.invoiceId}}</span></dd><dt><span>Datum</span></dt><dd><span>{{vm.invoice.date | date:\'d. MMM yyyy\'}}</span></dd><dt><span>Preis (\u20AC)</span></dt><dd><span>{{vm.invoice.fee}}</span></dd><dt><span>Rechnung gestellt</span></dt><dd><span>{{vm.invoice.issued | date:\'d. MMM yyyy, HH:mm\'}}</span></dd><dt><span>Notizen</span></dt><dd><span>{{vm.invoice.notes}}</span></dd><h4>Empf\xE4nger</h4><dt><span>Firma</span></dt><dd><span>{{vm.invoice.recipientCompanyName}}</span></dd><dt><span>Vorname</span></dt><dd><span>{{vm.invoice.recipientFirstName}}</span></dd><dt><span>Nachname</span></dt><dd><span>{{vm.invoice.recipientLastName}}</span></dd><dt><span>Geschlecht</span></dt><dd><span>{{vm.invoice.recipientGender | gender}}</span></dd><dt><span>Name auf Rechnung</span></dt><dd><span>{{vm.company.recipientNameOnInvoice | checkmark}}</span></dd><dt><span>PLZ</span></dt><dd><span>{{vm.invoice.recipientZip}}</span></dd><dt><span>Land</span></dt><dd><span>{{vm.invoice.recipientCountry}}</span></dd><dt><span>Stra\xDFe</span></dt><dd><span>{{vm.invoice.recipientStreetName}}</span></dd><dt><span>Stra\xDFennummer</span></dt><dd><span>{{vm.invoice.recipientStreetNumber}}</span></dd><dt><span>Ort</span></dt><dd><span>{{vm.invoice.recipientCity}}</span></dd><dt><span>Email</span></dt><dd><span>{{vm.invoice.recipientEmail}}</span></dd></dl></div>');
$templateCache.put('app/entities/invoice/invoice-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInvoiceLabel">Rechnung erstellen oder bearbeiten</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="invoiceId">Rechnungsnummer</label><input type="text" class="form-control" id="invoiceId" name="invoiceId" ng-model="vm.invoice.invoiceId"></div><div class="form-group"><label class="control-label" for="field_date">Datum</label><div class="input-group"><input id="field_date" type="text" required class="form-control" name="date" datetime-picker="{{dateformat}}" ng-model="vm.invoice.date" is-open="vm.datePickerOpenStatus.date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_fee">Preis (\u20AC)</label><input type="number" required class="form-control" name="fee" id="field_fee" ng-model="vm.invoice.fee"><div ng-show="editForm.fee.$invalid"><p class="help-block" ng-show="editForm.fee.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_issued">Rechnung gestellt</label><div class="input-group"><input id="field_issued" type="text" class="form-control" name="issued" datetime-picker="{{dateformat}}" ng-model="vm.invoice.issued" is-open="vm.datePickerOpenStatus.issued"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_notes">Notizen</label><textarea class="form-control" name="notes" id="field_notes" ng-model="vm.invoice.notes"></textarea></div><h4>Empf\xE4nger</h4><div class="form-group"><label class="control-label" for="field_recipientCompanyName">Firma</label><input type="text" class="form-control" name="recipientCompanyName" id="field_recipientCompanyName" ng-model="vm.invoice.recipientCompanyName" ng-maxlength="255" required><div ng-show="editForm.recipientCompanyName.$invalid"><p class="help-block" ng-show="editForm.recipientCompanyName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientFirstName">Vorname</label><input type="text" class="form-control" name="recipientFirstName" id="field_recipientFirstName" ng-model="vm.invoice.recipientFirstName" ng-maxlength="255" required><div ng-show="editForm.recipientFirstName.$invalid"><p class="help-block" ng-show="editForm.recipientFirstName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientLastName">Nachname</label><input type="text" class="form-control" name="recipientLastName" id="field_recipientLastName" ng-model="vm.invoice.recipientLastName" ng-maxlength="255" required><div ng-show="editForm.recipientLastName.$invalid"><p class="help-block" ng-show="editForm.recipientLastName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientGender">Geschlecht</label><select class="form-control" name="recipientGender" ng-model="vm.invoice.recipientGender" id="field_recipientGender" required><option value="MALE">M\xE4nnlich</option><option value="FEMALE">Weiblich</option></select><div ng-show="editForm.recipientGender.$invalid"><p class="help-block" ng-show="editForm.recipientGender.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientNameOnInvoice">Vor- und Nachname auf Rechnung</label><input type="checkbox" name="recipientNameOnInvoice" id="field_recipientNameOnInvoice" ng-model="vm.invoice.recipientNameOnInvoice"></div><div class="form-group"><label class="control-label" for="field_recipientZip">PLZ</label><input type="text" required class="form-control" name="recipientZip" id="field_recipientZip" ng-model="vm.invoice.recipientZip" ng-maxlength="255"><div ng-show="editForm.recipientZip.$invalid"><p class="help-block" ng-show="editForm.recipientZip.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientCountry">Land</label><input type="text" class="form-control" name="recipientCountry" id="field_recipientCountry" ng-model="vm.invoice.recipientCountry" ng-maxlength="255"></div><div class="form-group"><label class="control-label" for="field_recipientStreetName">Stra\xDFe</label><input type="text" required class="form-control" name="recipientStreetName" id="field_recipientStreetName" ng-model="vm.invoice.recipientStreetName" ng-maxlength="255"><div ng-show="editForm.recipientStreetName.$invalid"><p class="help-block" ng-show="editForm.recipientStreetName.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientStreetNumber">Stra\xDFennummer</label><input type="text" required class="form-control" name="recipientStreetNumber" id="field_recipientStreetNumber" ng-model="vm.invoice.recipientStreetNumber" ng-maxlength="255"><div ng-show="editForm.recipientStreetNumber.$invalid"><p class="help-block" ng-show="editForm.recipientStreetNumber.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientCity">Ort</label><input type="text" required class="form-control" name="recipientCity" id="field_recipientCity" ng-model="vm.invoice.recipientCity" ng-maxlength="255"><div ng-show="editForm.recipientCity.$invalid"><p class="help-block" ng-show="editForm.recipientCity.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_recipientEmail">Email</label><input type="email" required class="form-control" name="recipientEmail" id="field_recipientEmail" ng-model="vm.invoice.recipientEmail" ng-maxlength="255"><div ng-show="editForm.recipientEmail.$invalid"><p class="help-block" ng-show="editForm.recipientEmail.$error.required">Dieses Feld ist verpflichtend.</p><p class="help-block" ng-show="editForm.recipientEmail.$error.email">Email ung\xFCltig.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></div></form>');
$templateCache.put('app/entities/invoice/invoice-email-dialog.html','<form name="sendInvoiceEmailForm" ng-submit="vm.sendPDFEmail(vm.invoice.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Email-Rechnung senden</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Wollen Sie die Rechnung wirklich an den Kunden senden?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-warning"><span class="glyphicon glyphicon-envelope"></span>&nbsp;<span>Senden</span></button></div></form>');
$templateCache.put('app/entities/invoice/invoices.html','<div><h2>Rechnungen</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="invoiceId"><span>Rechnungsnummer</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th><span>Notes</span></th>--><th jh-sort-by="fee"><span>Preis (\u20AC)</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="recipientCompanyName"><span>Firma</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th><span>Recipient Name</span></th>--><!--<th><span>Recipient Zip</span></th>--><!--<th><span>Recipient Country</span></th>--><!--<th><span>Recipient Street Name</span></th>--><!--<th><span>Recipient Street Number</span></th>--><!--<th><span>Recipient City</span></th>--><!--<th><span>Recipient Email</span></th>--><th jh-sort-by="date"><span>Datum</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="issued"><span>Rechnung gestellt</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contractId"><span>Vertrag</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="invoice in vm.invoices track by invoice.id"><!--<td><a ui-sref="invoice-detail({id:invoice.id})">{{invoice.id}}</a></td>--><td>{{invoice.invoiceId}}</td><td>{{invoice.fee}}</td><td>{{invoice.recipientCompanyName}}</td><!--<td>{{invoice.recipientName}}</td>--><!--<td>{{invoice.recipientZip}}</td>--><!--<td>{{invoice.recipientCountry}}</td>--><!--<td>{{invoice.recipientStreetName}}</td>--><!--<td>{{invoice.recipientStreetNumber}}</td>--><!--<td>{{invoice.recipientCity}}</td>--><!--<td>{{invoice.recipientEmail}}</td>--><td>{{invoice.date | date:\'medium\'}}</td><td>{{invoice.issued | date:\'medium\'}}</td><td><a ui-sref="contract-detail({id:invoice.contractId})">{{invoice.contractId}}</a></td><!--<td class="text-right">--><!--<div class="btn-group flex-btn-group-container">--><!--<button type="submit"--><!--ui-sref="invoice-detail({id:invoice.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="invoice.edit({id:invoice.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="invoice.delete({id:invoice.id})"--><!--class="btn btn-danger btn-sm">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-sm-down"></span>--><!--</button>--><!--</div>--><!--</td>--></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/news/news-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.news.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Diese News wirklich l\xF6schen?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/news/news-detail.html','<div><h2><span>News</span> {{vm.news.title}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Titel</span></dt><dd><span>{{vm.news.title}}</span></dd><dt><span>Inhalt</span></dt><dd><span>{{vm.news.content}}</span></dd><dt><span>URL</span></dt><dd><span>{{vm.news.url}}</span></dd><dt><span>Startdatum</span></dt><dd><span>{{vm.news.startDate | date:\'medium\'}}</span></dd><dt><span>Enddatum</span></dt><dd><span>{{vm.news.endDate | date:\'medium\'}}</span></dd><dt><span>Aktiv</span></dt><dd><span>{{vm.news.active | checkmark}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Zur\xFCck</span></button> <button type="button" ui-sref="news-detail.edit({id:vm.news.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Bearbeiten</span></button></div>');
$templateCache.put('app/entities/news/news-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNewsLabel">News erstellen oder bearbeiten</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_title">Titel</label><input type="text" required class="form-control" name="title" id="field_title" ng-model="vm.news.title"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_content">Inhalt</label><textarea class="form-control" name="content" id="field_content" ng-model="vm.news.content"></textarea></div><div class="form-group"><label class="control-label" for="field_url">URL</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.news.url"></div><div class="form-group"><label class="control-label" for="field_startDate">Startdatum</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" datetime-picker="{{dateformat}}" ng-model="vm.news.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_endDate">Enddatum</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" datetime-picker="{{dateformat}}" ng-model="vm.news.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_active">Aktiv</label><input type="checkbox" name="active" id="field_active" ng-model="vm.news.active"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></div></form>');
$templateCache.put('app/entities/news/news.html','<div><h2>News</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="news.new"><span class="glyphicon glyphicon-plus"></span> <span>Neue News erstellen</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><!--<th><span>ID</span></th>--><th><span>Titel</span></th><th><span>Inhalt</span></th><th><span>URL</span></th><th><span>Startdatum</span></th><th><span>Enddatum</span></th><th><span>Aktiv</span></th><th></th></tr></thead><tbody><tr ng-repeat="news in vm.news track by news.id"><!--<td><a ui-sref="news-detail({id:news.id})">{{news.id}}</a></td>--><td>{{news.title}}</td><td>{{news.content}}</td><td>{{news.url}}</td><td>{{news.startDate | date:\'medium\'}}</td><td>{{news.endDate | date:\'medium\'}}</td><td>{{news.active | checkmark}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="news-detail({id:news.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="news.edit({id:news.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="news.delete({id:news.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/state/state-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.state.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">L\xF6schen best\xE4tigen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Dieses Bundesland wirklich l\xF6schen?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>L\xF6schen</span></button></div></form>');
$templateCache.put('app/entities/state/state-detail.html','<div><h2><span>{{vm.state.name}}</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.state.name}}</span></dd><dt><span>Bild</span></dt><dd><div ng-if="vm.state.image"><a ng-click="vm.openFile(vm.state.imageContentType, vm.state.image)"><img data-ng-src="{{\'data:\' + vm.state.imageContentType + \';base64,\' + vm.state.image}}" style="max-width: 100%" alt="state image"> </a>{{vm.state.imageContentType}}, {{vm.byteSize(vm.state.image)}}</div></dd><dt><span>Position</span></dt><dd><span>{{vm.state.position}}</span></dd><dt><span>Angrenzende Betriebe</span></dt><dd><span ng-repeat="adjacentCompany in vm.state.adjacentCompanies"><a ui-sref="company-detail({id: adjacentCompany.id})">{{adjacentCompany.name}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Zur\xFCck</span></button> <button type="button" ui-sref="state-detail.edit({id:vm.state.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Bearbeiten</span></button></div>');
$templateCache.put('app/entities/state/state-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myStateLabel">Bundesland erstellen oder bearbeiten</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input required type="text" class="form-control" name="name" id="field_name" ng-model="vm.state.name"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Dieses Feld ist verpflichtend.</p></div></div><div class="form-group"><label class="control-label" for="field_position">Position</label><input type="number" class="form-control" name="position" id="field_position" ng-model="vm.state.position"></div><div class="form-group" ngf-drop ngf-change="vm.setImage($file, vm.company)" ngf-pattern="\'image/*\'"><label class="control-label" for="field_image">Bild</label><div><img data-ng-src="{{\'data:\' + vm.state.imageContentType + \';base64,\' + vm.state.image}}" style="max-height: 100px" ng-if="vm.state.image" alt="state image"><div ng-if="vm.state.image" class="help-block clearfix"><span class="pull-left">{{vm.state.imageContentType}}, {{vm.byteSize(vm.state.image)}}</span> <button type="button" ng-click="vm.cstate.image=null;vm.state.imageContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImage($file, vm.state)" accept="image/*">Bild hinzuf\xFCgen</button></div><input type="hidden" class="form-control" name="image" id="field_image" ng-model="vm.state.image" required> <input type="hidden" class="form-control" name="imageContentType" id="field_imageContentType" ng-model="vm.state.imageContentType"><div ng-show="editForm.image.$invalid"><p class="help-block" ng-show="editForm.image.$error.required">Dieses Feld ist verpflichtend.</p></div></div><!--<div class="form-group">--><!--<label for="field_adjacentCompanies">Angrenzende Betriebe</label>--><!--<select class="form-control" id="field_adjacentCompanies" multiple name="adjacentCompanies" ng-model="vm.state.adjacentCompanies" ng-options="company as company.name for company in vm.companies track by company.id"></select>--><!--</div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Abbrechen</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Speichern</span></button></div></form>');
$templateCache.put('app/entities/state/states.html','<div><h2>Bundesl\xE4nder</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="state.new"><span class="glyphicon glyphicon-plus"></span> <span>Neues Bundesland erstellen</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><!--<th><span>ID</span></th>--><th><span>Name</span></th><th><span>Position</span></th><th><span>Angrenzende Betriebe</span></th><th></th></tr></thead><tbody><tr ng-repeat="state in vm.states track by state.id"><!--<td><a ui-sref="state-detail({id:state.id})">{{state.id}}</a></td>--><td>{{state.name}}</td><td>{{state.position}}</td><td><span ng-repeat="adjacentCompany in state.adjacentCompanies"><a class="form-control-static" ui-sref="company-detail({id: adjacentCompany.id})">{{adjacentCompany.name}}</a>{{$last ? \'\' : \', \'}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="state-detail({id:state.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="state.edit({id:state.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="state.delete({id:state.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-8"><h1>Oops!</h1><div class="alert alert-danger">Sie sind nicht berechtigt diese Seite zu sehen.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-8"><h1>Oops!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo.png" alt="logo"> <span>Schulausflug</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="daytrip" ng-click="vm.collapseNavbar()"><i class="fa fa-sun-o"></i> <span class="hidden-sm">Tagesausfl\xFCge</span></a></li><li ui-sref-active="active"><a ui-sref="accommodation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm">Projekttage/Projektwochen</span></a></li><li ui-sref-active="active"><a ui-sref="buscompany" ng-click="vm.collapseNavbar()"><i class="fa fa-bus"></i> <span class="hidden-sm">Busunternehmen</span></a></li><li ui-sref-active="active"><a ui-sref="contact" ng-click="vm.collapseNavbar()"><span class="hidden-sm">Kontakt</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm">Administration </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="company" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Betriebe</span></a></li><li ui-sref-active="active"><a ui-sref="state" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Bundesl\xE4nder</span></a></li><li ui-sref-active="active"><a ui-sref="news" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>News</span></a></li><li ui-sref-active="active"><a ui-sref="contract" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Vertr\xE4ge</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Rechnungen</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" has-authority="ROLE_ADMIN">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span>Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span>Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span>Intern</span></a></li></ul></li><!--<li ng-class="{active: vm.$state.includes(\'admin\')}"  ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer">--><!--<a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu">--><!--<span>--><!--<span class="glyphicon glyphicon-wrench"></span>--><!--<span class="hidden-sm">Service</span>--><!--<b class="caret"></b>--><!--</span>--><!--</a>--><!--<ul class="dropdown-menu" uib-dropdown-menu>--><!--<li ui-sref-active="active">--><!--<a ui-sref="user-management" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-user"></span>&nbsp;--><!--<span>User management</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-dashboard"></span>&nbsp;--><!--<span>Metrics</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="jhi-health" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-heart"></span>&nbsp;--><!--<span>Health</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-list-alt"></span>&nbsp;--><!--<span>Configuration</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="audits" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-bell"></span>&nbsp;--><!--<span>Audits</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="logs" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-tasks"></span>&nbsp;--><!--<span>Logs</span>--><!--</a>--><!--</li>--><!--<li ng-show="vm.swaggerEnabled" ui-sref-active="active">--><!--<a ui-sref="docs" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-book"></span>&nbsp;--><!--<span>API</span>--><!--</a>--><!--</li>--><!--&lt;!&ndash; jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here &ndash;&gt;--><!--</ul>--><!--</li>--></ul></div></div></nav>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Reset your password</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p>Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Your email" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset</button></form></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Reset password</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button></form></div></div></div></div>');}]);})();